var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRabbitWorking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3333.3333 2666.6667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3496.59,1904.3 h 18006.8 V 5366.8 H 3496.59 Z",
    id: "path20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath218"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13101.5,4793.6 c -11.8,55.8 -21.5,111.8 -30.7,167.9 v 0 c 9.2,-56.1 18.9,-112.1 30.7,-167.9",
    id: "path216"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.333333, 0, 0, -1.333333, 0, 2666.666748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    clipPath: "url(#clipPath22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21148.1,4289 c 0,-1213.3 -3920.7,-2196.8 -8757.1,-2196.8 -4836.38,0 -8757.06,983.5 -8757.06,2196.8 0,75.8 -23.69,434.6 6.2,508.4 448.46,1107.8 4216.76,1688.4 8750.86,1688.4 4534.2,0 8306.2,-592.5 8754.7,-1700.2 29.9,-73.9 2.4,-420.8 2.4,-496.6",
    style: {
      fill: "#d27f76",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21148.1,4722.4 c 0,-1213.3 -3920.7,-2196.8 -8757.1,-2196.8 -4836.38,0 -8757.06,983.5 -8757.06,2196.8 0,1213.2 3920.68,2196.8 8757.06,2196.8 4836.4,0 8757.1,-983.6 8757.1,-2196.8",
    style: {
      fill: "#e1c585",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12391,2525.6 c -82.5,0 -164.7,0.3 -246.6,0.8 81.8,-0.5 164.3,-0.8 246.6,-0.8 112.5,0 224.5,0.5 335.9,1.6 -111.4,-1.1 -223.4,-1.6 -335.9,-1.6 m -247.5,0.8 c -0.8,0 -1.6,0 -2.3,0.1 0.8,-0.1 1.4,-0.1 2.3,-0.1",
    style: {
      fill: "#da9b7f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21099.6,4489.7 c 0,0.1 0.1,0.3 0.1,0.4 0,-0.2 -0.1,-0.2 -0.1,-0.4 m 0.7,1.8 c 0.1,0.2 0.2,0.4 0.3,0.6 -0.1,-0.2 -0.2,-0.4 -0.3,-0.6 m 0.6,1.3 c 0.2,0.5 0.3,0.9 0.5,1.3 -0.2,-0.4 -0.3,-0.9 -0.5,-1.3 m 0.7,1.7 c 30.7,74.9 46.5,150.9 46.5,227.9 0,20.6 -1.1,41.1 -3.4,61.6 2.3,-20.5 3.4,-41 3.4,-61.6 0,-77 -15.8,-153 -46.5,-227.9",
    style: {
      fill: "#db9a8d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 15611,14081.1 c -439.9,550.4 -972.6,971.3 -1584.8,1286.7 -1.5,-1.7 -2.1,-4.1 -3.9,-5.6 -16.1,-13.8 -31,-22.2 -51.1,-29 -10.1,-3.4 -20.5,-5.8 -30.6,-9.8 2.5,1 5,2.1 7.4,3.1 -17.9,-7.1 -35.1,-9.7 -54.7,-5.3 -20.4,4.7 -36.9,19.7 -47.9,36.9 -23.7,36.7 -7.1,88 28.7,109.7 24.9,15 49,31.1 72.5,48.2 11,7.9 21.8,16.1 32.6,24.2 1.5,1.2 2.9,2.4 4.4,3.5 4.8,3.8 9.5,7.5 14.3,11.2 29.4,23.3 59,46.3 89.1,68.8 146,216 246.9,467.5 175.3,731.3 -152.2,561.1 -869.6,673.2 -1352.4,557.4 -296,-71.1 -570.6,-217.7 -801.8,-414.4 -121,-103 -227.8,-221.5 -319.3,-351.4 -71.5,-101.5 -115,-251.3 -217.3,-317.8 29.3,-44.1 7.8,-125.7 -63.8,-133.1 -403.6,-41.9 -806.4,-110.9 -1213.6,-102 -28.5,0.6 -48.9,13.6 -61.7,31.6 -151.6,-49.2 -299.55,-107.9 -443.69,-175 208.67,479.3 516.39,914.5 699.69,1407.3 30.7,57.7 59.7,116 84.4,176.2 123.4,301.3 67.7,602 -191,809.6 -215.8,173.3 -497.26,275.2 -759.82,150.4 -582.18,-276.7 -998.01,-926.3 -1215.46,-1509 -138.2,-370.2 -209.98,-769.3 -243.42,-1162.3 -17.08,-200.5 -80.46,-614.1 46.95,-830.2 C 7004.72,13472 6408.5,11877.2 6603.13,10304.7 c 110.68,-894.2 447.43,-1693.1 1162.65,-2265.5 360.67,-288.6 751.34,-548.6 1171.39,-742.6 205.25,-94.9 485.84,-194.8 762.5,-257.8 -244.52,-130.6 -479.56,-304.1 -711.58,-454.6 -61.21,73.7 -198.02,42.4 -246.08,-49.9 91.91,-285.5 156.39,-581.7 190.17,-880 20.96,-14.4 46.88,-20.7 75.28,-10.5 260.05,92.6 507.05,203.8 766.03,290.3 1.59,-61.4 30.78,-150.3 42.03,-173.6 11.93,-24.7 26.86,-47.1 43.7,-67.8 17.25,-2.4 34.27,-9.9 48.91,-21.5 167.27,-132.9 380.67,-147.9 585.37,-128.3 41.8,4 82.1,-39.8 80.2,-80.2 -0.7,-16.3 -0.7,-20.8 2.7,-34.8 1.1,-4.5 3.2,-7.2 5.7,-9.7 11.2,-11.4 23.9,-18.9 40.7,-24.8 10.3,-3.7 20,-6.4 29.6,-8.9 1038.6,-8.7 2077.3,-50.5 3116.3,-50.1 7,-9.5 14.1,-18.9 21.3,-28.2 124.7,-4.4 250,5 375.1,9.7 7.3,8.8 14.1,17.9 19.9,27.7 4.2,7 7.4,14.1 11.3,21.2 5.6,4.5 10,10 14.7,15.3 7.2,-2.9 14.3,-5.9 22.1,-8.3 36,-11 71.3,17.6 80.7,50.5 19.4,67.8 0.9,133.8 -40.2,188.1 26.2,234.7 -66.8,473 -152.7,703.6 -96.3,258.3 -184.9,523.1 -286.1,781.6 -24.1,14.7 -40.9,42.9 -40.9,70.1 0,46 37.1,76.5 80.2,80.2 189.7,16.5 368.1,110.7 537.9,195.6 3.3,1.7 6.9,1.9 10.3,3.2 118.1,74.6 323.7,139.1 437.4,219.8 655.7,466.2 1250.7,895.6 1575.2,1653.6 l 14.3,159.7 c 699,1531.7 172,3339.3 -838.2,4603.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20297.3,6268.1 c 35.6,414.6 4.3,897.1 -249.9,1235 -248.5,330.2 -704.8,620.9 -1091.4,752.4 -868.5,295.7 -1763,-58.4 -2257.1,-809.1 -6.7,-10.2 -10.2,-20.7 -11.3,-31 -129.4,-182.1 -190.5,-391.8 -199.7,-611.1 -69.4,-261.5 -91.2,-534.8 -49,-807.4 88.8,-573.6 519.8,-909 1052,-1076.4 551,-173.4 1200.6,-189.1 1758.3,-39.3 261.7,70.4 550.2,183 751.3,371 39.5,37 73.8,76.8 103.6,118.8 171,114.6 323.1,264.4 370.1,465.2 42.4,181.1 -25.2,350.7 -176.9,431.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(245, 235, 102)"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12484.5,5448.9 c -142.4,0.8 -284.9,1.5 -427.3,2.2 -250.1,1.3 -500.2,2.6 -750.4,3.8 -76.3,8.1 -152.3,16.4 -227.4,24.6 -50.6,5.5 -76.9,40.4 -80.1,77.2 -129.5,3 -258.8,10 -387.4,23.5 -284.6,29.9 -734.2,112.3 -602.3,505.5 12.2,36.4 45.6,53.9 78,53.9 39.7,0 77.9,-26.2 74.5,-76.3 -13.2,-189.3 390.3,-235.3 792.5,-235.3 322,0 643.3,29.5 749.5,38.5 140.5,11.9 291.6,42.9 425.8,42.9 189.9,0 345.8,-62.3 389.3,-329.3 8.3,-51.2 -5.2,-98.1 -34.7,-131.2",
    style: {
      fill: "#fde6df",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9237.19,5730.4 c 178.63,70.1 354.52,143 536.3,203.7 0.36,-13.7 2.09,-28.8 4.69,-44.2 -5.83,-4.2 -11.86,-8.3 -18.1,-12.3 -148.41,-95.2 -338.39,-129.4 -522.89,-147.2 m -314.31,0.1 c -94.1,51.1 -114.05,199.7 -46.36,283.3 18.46,-94 33.95,-188.5 46.36,-283.3 m -93.52,496.2 c -17.41,19.4 -34.06,40.4 -49.89,63 -31.25,44.6 -31.06,105.4 -10.53,158 21.95,-73.1 42.11,-146.8 60.42,-221 m 158.73,357.5 c -4.98,6 -10.47,11.3 -16.37,16 35.61,15.7 77.23,34 122.18,53.8 -35.35,-23.6 -70.62,-47 -105.81,-69.8",
    style: {
      fill: "#f9de77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8996.04,5712.7 c -27.91,0 -52.36,6.5 -73.16,17.8 -12.41,94.8 -27.9,189.3 -46.36,283.3 21.76,26.9 52.58,47 92.91,55.1 21.2,4.2 42.02,9.2 62.99,13.9 -75.04,29.7 -143.51,77.5 -203.06,143.9 -18.31,74.2 -38.47,147.9 -60.42,221 17.02,43.7 48.02,81.8 86.68,100.5 13.24,6.4 56.18,25.5 116.1,52 5.9,-4.7 11.39,-10 16.37,-16 35.19,22.8 70.46,46.2 105.81,69.8 250.46,110.5 604.59,267.5 601.88,279.4 -8.62,37.4 -0.1,71.1 17.91,98.3 -0.15,1.2 -0.3,2.5 -0.44,3.7 128.64,-24.5 257.44,-45.4 385.55,-63 113.9,-15.7 228.1,-29.3 342.5,-40.6 3.2,-0.3 6.2,-0.5 9.2,-0.5 93.4,0 89.7,151.1 -9.2,160.9 -710.52,70.3 -1445.87,225 -2084.29,561.1 25.65,80.8 39.67,166.6 39.67,255.9 0,14.7 -0.38,29.4 -1.12,43.9 442.63,-223.7 930.02,-373.9 1396.65,-507.5 380.69,-109 766.29,-230.5 1156.49,-299.3 207.9,-36.7 409.7,-46.8 611.6,-46.8 208.9,0 417.9,10.8 633.5,14.3 1.1,0 2.2,0 3.2,0 178.2,0 174.9,-238.4 29.2,-291.5 -178.3,-65.1 -371.1,-88.4 -566.3,-88.4 -31.2,0 -62.4,0.6 -93.6,1.7 -127.1,-190.6 -406.3,-214.7 -621.4,-267.1 -116.6,-28.3 -236.6,-57 -357.4,-57 -19.3,0 -38.7,0.8 -58,2.3 -43.3,3.6 -91.3,11.7 -132.7,24.7 -5,2 -9.7,4.6 -14.7,6.6 -31.4,-102.3 -130,-185.4 -229.4,-188 -46.3,-17.3 -91.9,-26.8 -136.7,-26.8 -20.67,0 -41.17,2 -61.48,6.3 -23.21,-134.6 -57.69,-261 -176.34,-346.7 -2.6,15.4 -4.33,30.5 -4.69,44.2 -181.78,-60.7 -357.67,-133.6 -536.3,-203.7 -78.24,-7.6 -155.51,-12.2 -228.18,-17.3 -4.42,-0.3 -8.72,-0.4 -12.97,-0.4 M 10691.7,8107 c -202.2,0 -407.8,41.5 -608.6,132.8 -463.81,211 -750.91,595.2 -875.57,1037.5 -14.99,-24.7 -39.19,-44.1 -73.1,-52 -90.24,-20.9 -186.72,-26.3 -281.53,-32 -15.99,-331.2 -261.09,-698.3 -546.87,-901.9 -19.83,39.2 -42.64,76.8 -68.1,112.3 68.6,60.5 129.58,129.6 180.54,207 142.64,216.7 212.29,482.7 219.5,760.7 14.48,14.5 30.77,24.3 47.7,29.9 9.54,5.3 19.95,9.5 32.19,11.5 127.57,20.9 260,54.7 389.29,57.7 1.01,0 2.01,0.1 3.01,0.1 22,0 40.71,-5.7 56.64,-14.7 -61.06,339.7 -33.26,703 78.21,1042.5 10.21,31.2 30.37,50.4 53.83,59.7 -148.81,-354.4 -182.19,-770.9 -66.56,-1190.5 182.44,-662 639.99,-1084.2 1251.62,-1173.4 82.5,-12 167.4,-18 253.5,-18 207.2,0 421.1,35 624,105.9 3,-6.7 6,-13.4 9.1,-20 -213.5,-99.1 -444,-155.1 -678.8,-155.1",
    style: {
      fill: "#fde6df",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13866,15452.2 c -2.6,0.9 -5.2,1.8 -7.8,2.7 4.7,5 10.1,9.3 15.9,12.9 2.4,1.4 4.7,2.8 7,4.2 -5,-6.6 -10,-13.2 -15.1,-19.8 m 175.5,1254.6 c -66.5,57.8 -143.2,104.4 -226.2,140.9 16.8,19.3 41.7,28.7 67.7,28.7 33.2,0 68.1,-15.4 90,-45.6 26.5,-36.8 49.3,-78.6 68.5,-124",
    style: {
      fill: "#f9de77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12291,13974.8 c -82.4,0 -172.7,78.8 -144.5,173.5 148.3,498.5 483.9,810.7 874.4,1131.8 202.7,166.6 402.3,331.5 549.8,551.2 80.2,119.6 156.3,248.7 204.4,385 68.2,192.8 16.4,373.9 19,570.6 0.4,26 8.4,46.2 21.2,60.8 83,-36.5 159.7,-83.1 226.2,-140.9 106.9,-252.5 104.8,-617.8 36.3,-853.2 -40.6,-139.9 -110.6,-266.1 -196.7,-381.6 -2.3,-1.4 -4.6,-2.8 -7,-4.2 -5.8,-3.6 -11.2,-7.9 -15.9,-12.9 -0.6,0.3 -1.2,0.5 -1.7,0.7 -9.7,3.3 -18.8,4.9 -27.3,4.9 -58.6,0 -87.4,-74.2 -59.7,-123.5 -45.4,-50.2 -93.3,-98.2 -142.1,-144.4 -392.2,-370.5 -1007.4,-639.3 -1234.1,-1149.8 -21.3,-48 -60.8,-68 -102.3,-68",
    style: {
      fill: "#fde6df",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10133.8,16122.9 c 130.9,238.9 259.5,479 354.6,734.7 12.8,24.1 25.3,48.3 37.4,72.7 -2.8,-10.2 -5.7,-20.4 -8.7,-30.5 -81.2,-272 -224.3,-539 -383.3,-776.9",
    style: {
      fill: "#f9de77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9365.58,15352.6 c 0.76,7.3 2.52,14.7 5.41,22.3 84.4,220.4 219.69,417.8 312.86,635.5 81.76,191 152.92,384.5 243.97,571.5 158.28,325 493.28,997.3 12.92,1242.8 -94.61,48.4 -32.18,170.7 55.22,170.7 5.54,0 11.24,-0.5 17.04,-1.5 519.7,-95 637.2,-607.7 512.8,-1063.6 -12.1,-24.4 -24.6,-48.6 -37.4,-72.7 -95.1,-255.7 -223.7,-495.8 -354.6,-734.7 -17.4,-26.1 -35.1,-52 -52.9,-77.4 -122.81,-175.3 -236.19,-369.5 -364.2,-547.4 -118.84,-43.8 -235.93,-92.3 -351.12,-145.5",
    style: {
      fill: "#fde6df",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12989.2,8622.2 c 0,-469.1 -380.2,-849.3 -849.3,-849.3 -469,0 -849.3,380.2 -849.3,849.3 0,469 380.3,849.3 849.3,849.3 469.1,0 849.3,-380.3 849.3,-849.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(253, 211, 237)"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7298.26,8434.2 c 146.42,-244 365.12,-448.6 594.26,-614.2 132.15,-95.4 277.34,-188.4 431.75,-253.2 46.25,104.8 72.41,220.5 72.41,342.4 0,469 -380.26,849.3 -849.33,849.3 -126.84,0 -246.74,-28.6 -354.81,-78.4 20.7,-86.8 59.78,-169.4 105.72,-245.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(253, 211, 237)"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11394.8,14391.2 c -41.8,415.1 1166.7,2508.1 1580.3,1671.4 204.7,-414.2 -497.2,-873.1 -721,-1143.4 -191.3,-231 -227.9,-563.8 -385.3,-767.8 -137.4,362.4 -170.8,-70.1 -375.1,-18.6 1.5,46.1 -28.5,87.6 -24.9,132.2 -36.7,-23.8 -92.8,-21.9 -120.2,-37.7 -7.4,55.7 16.6,94 46.2,163.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(253, 211, 237)"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8668.78,16927.6 c 158.4,291.8 694.14,760.1 883.34,285.9 161.26,-404.1 -181.31,-797.2 -348.25,-1140.7 -178.03,-366.3 -407.83,-765.8 -491.73,-1156 -37.12,-24.9 -120.64,-49.8 -163.57,-49.8 -13.88,39 -56.15,69.9 -67.74,92.8 -89.42,-112.6 -129.16,-272.2 -257.08,-348.5 -238.33,548.2 12.23,1376.8 207.99,1889.6 99.1,259.6 263.05,500.8 237.04,426.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(253, 211, 237)"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9990.18,5646.7 c -325.67,18.3 -658.9,38.9 -985.82,29.1 -21.72,94.1 -44.22,187.3 -62.58,277.7 -61.92,305 -129.45,609.5 -217.86,908.2 -50.72,171.2 -116.53,356.5 -283.08,448.1 -210.16,115.6 -531.32,77.9 -761.43,89.1 -621.41,30.3 -1243.87,60.5 -1865.83,75.4 -463.16,11.1 -1052.08,102.3 -1422.31,-243.7 0.18,-1.2 0.55,-2.5 0.7,-3.7 20.83,-178.8 31.28,-358.8 63.96,-535.5 1.67,-9 1.46,-18 0.73,-26.8 10.18,-35.6 21.04,-71.7 32.13,-108.5 75.6,-251 153.05,-501.3 232.25,-751.1 90.95,-286.8 153.03,-636.5 411.33,-782 -4.28,-110.7 64.92,-221.6 182.94,-274.5 151.51,-67.9 357.49,-60.5 519,-77.7 212.17,-22.6 424.48,-44.3 636.47,-68.5 409.47,-46.9 818.29,-103.8 1230.35,-122.6 433.41,-19.7 863.11,-22.6 1294.64,-71.8 98.51,-11.2 161.14,46.9 186.51,122.3 235.04,112.1 457.64,267.2 670.62,409.2 156.3,104.2 522,281.2 519.2,499.7 -2.5,198.4 -234.9,199.4 -381.92,207.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6721.78,5631.4 c -189.05,-143.1 -474.03,-63.9 -631.23,90.3 -77.42,76 -133.73,184.1 -124.31,295.1 7.13,83.9 44.85,157.2 101.63,214.3 3.52,6.2 25.6,39.6 31.24,44.4 205.62,176.2 607.59,139.2 701.76,-154.9 5.54,-17.3 8.72,-34.9 10.83,-52.5 28.56,-54.5 46.65,-113.9 47.05,-176.6 0.7,-106.2 -53.91,-197.2 -136.97,-260.1 z M 8963.34,4599.3 c -17.95,20.8 -25.86,52 -18.76,76.7 0.81,2.8 2.63,4.5 3.68,7.1 -62.13,333.2 -149.53,663.3 -210.69,995 -76.2,413.1 -190.43,812.1 -331.32,1207.5 -24.19,67.9 -57.03,134.5 -115.51,179.3 -32.83,25.1 -71.31,43.5 -111.49,58.1 -12.27,1.4 -24.41,2.8 -36.07,4.3 -112.46,14.5 -224.4,31.5 -336.36,48.2 -22.84,0.8 -45.65,1.6 -68.42,2.8 -120.36,6.3 -240.68,13.8 -360.96,21.2 -475.08,29.2 -949.91,62.1 -1425.03,90.4 -464.76,27.7 -932.47,-42.7 -1395.67,12.7 -18.53,2.2 -33.64,9.4 -45.45,19.6 -41.87,-26.7 -82.33,-56.3 -120.02,-91.6 0.18,-1.2 0.55,-2.5 0.7,-3.7 20.83,-178.8 31.28,-358.8 63.96,-535.5 1.67,-9 1.46,-18 0.73,-26.8 10.18,-35.6 21.04,-71.7 32.13,-108.5 75.6,-251 153.05,-501.3 232.25,-751.1 90.95,-286.8 153.03,-636.5 411.33,-782 -4.28,-110.7 64.92,-221.6 182.94,-274.5 151.51,-67.9 357.49,-60.5 519,-77.7 212.17,-22.6 424.48,-44.3 636.47,-68.5 409.47,-46.9 818.29,-103.8 1230.35,-122.6 432.44,-19.6 861.2,-22.6 1291.74,-71.5 -8.41,63.9 -18.59,127.6 -29.53,191.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(239, 212, 227)"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7384.01,7413.2 c -523.23,25.1 -1046.98,48.6 -1570.43,61.1 -1.25,0.1 -2.58,0.1 -3.83,0.2 23.38,-2.9 46.77,-5.9 70.16,-8.7 495.98,-58.1 996.85,-35.1 1494.24,-75.3 2.06,8.4 5.45,15.9 9.86,22.7",
    style: {
      fill: "#f256b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8540.48,7230 c 6.17,-5.5 11.8,-11.5 17.67,-17.2 -32.68,37.9 -70.74,71.4 -117.31,97 -15.14,8.3 -31.01,15.6 -47.25,22.4 52.4,-28.5 101.89,-62.2 146.89,-102.2",
    style: {
      fill: "#f256b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9686.83,5364.2 c -2.72,15 -6.69,29.5 -11.91,43.8 -3.05,6.4 -5.98,12.9 -9.63,19.1 -2.04,3.4 -3.4,6.9 -4.83,10.5 -44.9,18.4 -96.61,27 -148.04,31.7 -14.88,-23.2 -40.75,-40.6 -67.4,-37.4 -73.46,8.6 -149.71,-3.7 -223.42,-4.4 -52.63,-0.4 -130.53,1.3 -179.24,35 23.78,-110.6 47.59,-221.1 72.05,-331.5 8.28,-37.4 16.03,-75.2 24.07,-112.8 2.32,1.1 4.36,2.4 6.86,3.3 88.94,32.1 174.8,72.8 263.42,119.5 90.14,47.4 183.2,99 258.1,169 5.5,5.1 13.26,13 20.38,20.4 0.68,11.3 0.55,22.6 -0.41,33.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(76, 74, 76)"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9006.91,5675.8 h -2.55 c -21.72,94.1 -44.22,187.3 -62.58,277.7 -23.88,117.7 -49.12,235.1 -75.57,352.3 15.69,-75.7 32.27,-151.2 47.35,-226.8 27.21,-136.3 55.58,-272.3 84.27,-408.3 2.98,1.8 5.79,3.6 9.08,5.1",
    style: {
      fill: "#f256b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9912.24,5634.7 c -35.06,6.7 -70.02,13.8 -104.81,21.7 -52.84,2.8 -105.34,5.8 -158.35,8.4 88.65,-22 177.3,-46 265.79,-64.4 -3.13,11.1 -4.23,22.7 -2.63,34.3",
    style: {
      fill: "#f256b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20376.1,6137.4 v 0.2 c 22.9,136.8 -179.8,189.4 -232.7,63 C 19815,5415.8 18832.8,5083.9 18035.1,5192 c -875.7,118.8 -1645.6,871.3 -1490.2,1773.2 14.9,86.4 -14,129.7 -45.7,47.3 -128.5,-334.2 -120.7,-658.6 -18.3,-949.6 134,-668.7 797.2,-1164.5 1509.3,-1261.4 550.9,-75 1127.4,50.3 1626.8,284.7 387.2,181.9 848.1,494.6 906.7,955.6 12,94.5 -81.7,131.1 -147.6,95.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(248, 201, 74)"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17882.1,7037.9 c -14.2,21.4 -31.3,41.6 -54.5,58 -212.4,150.6 -682.6,-2.3 -554,-315.6 101.2,-246.4 560.8,-275.5 668.9,-19.5 41.8,99 9.6,204.2 -60.4,277.1",
    style: {
      fill: "#f46d17",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17121.9,6715.9 c -76.8,144.8 -231.5,246.6 -398.2,238 -82.1,-4.2 -155,-34.5 -215.6,-89.8 -33.6,-30.7 -52.5,-63.7 -65.5,-99.7 -138.4,-172.2 -80.3,-476.9 166.1,-553.4 138.5,-43 316.3,-19.1 434.2,68.1 141,104.4 157.6,288.6 79,436.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(248, 201, 74)"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18920,6778 c -3.8,6.1 -7.4,12.2 -11.4,18.3 -118.2,176.7 -326.6,203.3 -510.2,114.4 -172.2,-83.5 -296,-263.3 -227.2,-457.5 114.8,-323.8 741.7,-432.5 843.4,-43.7 33.4,127.4 -7.7,269 -94.6,368.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(248, 201, 74)"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19588.7,7787.6 c -65.2,90 -200.4,131.4 -295.9,62.1 -32.3,-23.4 -52.9,-55.5 -65.3,-91 -70.2,-83.9 -15.7,-228.2 48.9,-301.4 82.7,-93.7 240.4,-143.7 328.2,-24.6 70.1,95.1 51.2,262.4 -15.9,354.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19157.9,7961 c -0.2,1.7 -0.5,2.5 -1.1,4.7 -1.3,5.1 -0.9,4 -3.4,8.6 -1.1,1.9 -1.6,3.1 -2.7,4.6 -0.7,0.9 -5.5,5.8 -6.4,6.5 l -0.6,0.5 c -1.8,1.3 -6,3.7 -8,4.7 l -0.6,0.3 -1.3,0.4 c -3,1 -6.3,2.1 -9.5,2.5 -3.1,0.4 -6.6,0.3 -9.6,0.1 l -1.4,-0.2 c -2.9,-0.4 -6.6,-1.3 -9.3,-2.3 l -0.7,-0.4 c -1.8,-0.7 -6.4,-3.2 -7.9,-4.3 l -0.5,-0.4 c -1.2,-0.9 -5.7,-5.3 -6.7,-6.5 l -0.4,-0.5 c -0.9,-1.2 -4,-6.5 -4.7,-8 -2.6,-6.6 -3.2,-12.4 -2.7,-19.4 0.4,-4.5 1.8,-8.6 4.3,-12.2 1.8,-4.2 4.7,-7.6 8.4,-10.4 3.6,-3 7.6,-4.9 12.1,-5.7 4.1,-1.5 8.4,-1.9 12.9,-1.2 1.3,0.3 2.6,1 3.9,1.3 1.1,-0.1 2.1,-0.5 3.1,-0.4 4.2,-0.4 8.3,0.3 12.3,2 2.4,1.4 4.9,2.8 7.4,4.1 4.8,3.6 8.3,8.2 10.6,13.7 0.9,2.9 2.1,6.2 2.5,9.2 0.2,1.9 0.2,6.8 0,8.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15999.7,6160.5 c 13.8,312.7 -95.5,627.1 -297.7,865.5 -187.1,220.6 -514.4,460 -805.2,517 -360.4,70.7 -667,-184.2 -1011.6,-228 -9.5,-1.3 -18,-3.6 -25.9,-6.5 -68.3,40.4 -161.2,-30.5 -127.9,-105.4 -0.2,-16.2 4.8,-33.3 16.6,-50 359,-509.1 542.8,-1136.3 598.1,-1751.3 5.7,-63.8 73.5,-119.3 137.8,-107.7 405.8,73.6 761.9,27.5 1164.9,-15.4 98.1,-10.4 155.8,115.2 99.1,178.6 171.8,166.9 242.6,492.4 251.8,703.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(185, 231, 206)"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9225.14,4826 c -124.32,485.3 -225.3,977 -328.08,1467.3 -63.41,302.4 -116.63,636.4 -281.83,903.3 -72.69,117.5 -161.63,190.4 -298.6,213.6 -249.05,42.2 -501.36,60.9 -753.51,71.5 -527.56,22.2 -1056.25,38.9 -1584.2,47.7 -239.34,4 -478.24,3.2 -717.34,14.7 -183.31,8.8 -367.35,10.8 -540.89,-56 -117.68,-45.3 -272.22,-102.1 -335.67,-220.2 -45.01,-83.8 -16.18,-202.3 -4.54,-291.4 16.24,-124.3 41.79,-246.9 70.45,-368.9 114.39,-486.9 264.39,-973.5 447.98,-1439 33.22,-84.2 82.44,-157.4 164.96,-199.6 83.63,-42.8 178.21,-55.2 270.38,-65.5 243.36,-26.9 485.99,-57.3 729.96,-79 531.29,-47.2 1062.26,-96.7 1594.76,-128.6 265.77,-16 531.8,-28.7 797.95,-36.1 95.81,-2.7 191.56,-5.1 287.33,-8.4 57.94,-2 124.29,-0.6 170.92,38.8 55.05,46.6 52.66,119 40.11,183.9 -13.04,67.5 -116.11,38.9 -103.1,-28.4 14.32,-74.1 -13.91,-87.8 -82.4,-88 -79.12,-0.3 -158.95,5.3 -238.07,7.1 -242.54,5.7 -485,16.3 -727.23,29.6 -489.37,26.9 -977.39,68.9 -1465.47,112.8 -244.2,22 -488.73,41.2 -732.2,70.5 -97.37,11.7 -194.73,23.3 -292.09,35 -88.53,10.6 -195.93,25.4 -259.69,94.4 -62.7,67.9 -80.69,173.4 -111.95,257.7 -41.66,112.4 -81.68,225.3 -119.87,338.9 -77.18,229.5 -148.71,461.1 -210.35,695.3 -61.15,232.4 -123.11,470.1 -138.89,710.7 -5.55,84.6 1.67,125.2 73.08,175.3 54.15,38 115.77,66 177.09,90.3 158.15,62.6 316.35,70.6 485.16,64.1 212.4,-8.1 423.93,-12.3 636.52,-15 487.02,-6.1 973.56,-26.9 1460.37,-40.9 239.54,-6.9 479.33,-15.5 717.77,-40.6 109.09,-11.5 229.17,-17.7 334.68,-49.4 46.87,-14.1 84.11,-46.5 115.57,-83 89.62,-103.8 138.79,-243.5 179.9,-372.2 46.74,-146.2 81.16,-296.2 113.14,-446.3 87.87,-412.4 172.68,-825.6 267.7,-1236.5 27.67,-119.6 56.61,-238.9 87.09,-357.9 17.06,-66.6 120.22,-38.4 103.1,28.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9200.57,4747.1 c 378.43,258.9 775.53,505.7 1118.13,812.2 51.3,46 -24.5,121.4 -75.7,75.7 -335.67,-300.5 -725.5,-541.8 -1096.39,-795.6 -56.45,-38.6 -3.03,-131.3 53.96,-92.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9004.71,5606.6 c 415.63,-22.9 832.98,-25.1 1248.09,-56.1 68.6,-5.2 68.3,101.8 0,106.9 -415.11,31.1 -832.46,33.2 -1248.09,56.1 -68.75,3.8 -68.54,-103.2 0,-106.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5079.17,4971.1 c -2.87,-45.8 10.65,-92.4 28.27,-134.1 19.84,-47 47.64,-88.3 88.32,-119.5 10.2,-7.9 29.46,-8.7 41.19,-5.4 12.4,3.4 25.84,13 31.95,24.6 6.56,12.4 9.85,27.4 5.39,41.1 -4.58,14.2 -12.88,23 -24.57,32 14.84,-11.4 2.9,-2 -0.41,1.2 -3.13,2.9 -6.13,6 -9.01,9.2 -3,3.3 -5.64,6.9 -8.64,10.2 11.54,-12.6 1.33,-1.5 -1.47,2.7 -5.41,8 -10.36,16.2 -14.92,24.7 -2.33,4.4 -4.56,8.8 -6.69,13.2 -1.29,2.7 -2.5,5.4 -3.74,8.1 -3.86,8.4 3.71,-9.3 1.29,-3.2 -7.12,18.1 -13.22,36.4 -17.23,55.4 -0.94,4.5 -1.71,8.9 -2.48,13.4 -1.61,9.5 -0.33,-3.2 0.65,-5 -0.83,1.5 -0.5,4.7 -0.64,6.3 -0.72,8.4 -0.87,16.7 -0.35,25.1 1.76,28 -25.84,54.7 -53.46,53.5 -30.46,-1.4 -51.58,-23.6 -53.45,-53.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5247.61,4695.3 c 970.68,-135.4 1949.49,-191.7 2927.51,-243.8 277.72,-14.8 555.46,-29.4 833.11,-45.5 68.74,-3.9 68.51,103 0,106.9 -968.87,56.1 -1939.33,93.5 -2905.51,188.3 -276.16,27.1 -551.86,58.9 -826.69,97.2 -67.29,9.4 -96.39,-93.6 -28.42,-103.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9040.95,4406 c 47.12,-6 98.14,20.1 138.97,40.1 60.65,29.7 118.2,65.8 174.92,102.3 133.13,85.5 265.21,173.7 395.91,262.9 169.26,115.5 339.65,233.8 497.65,364.5 121.6,100.5 229.3,271.1 125.3,423.4 -38.6,56.5 -131.3,3.1 -92.3,-54 107.6,-157.6 -116.9,-302.2 -221.8,-381.3 -144.56,-109 -292.27,-213.8 -442.84,-314.3 -104.92,-70 -209.76,-140.7 -315.88,-208.9 -48.99,-31.5 -98.56,-62.4 -150.09,-89.6 -31.27,-16.5 -72.8,-42.9 -109.84,-38.2 -68.07,8.8 -67.44,-98.3 0,-106.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4472.23,7211.2 c 835.17,-11.4 1669.44,-53.1 2503.61,-92.8 212.07,-10.1 424.16,-19.5 636.22,-29.7 167.14,-8 339.59,-5.2 505.64,-26.6 173.98,-22.4 233.22,-172.4 283.71,-323.5 57.47,-172 91.35,-351.8 134.54,-527.7 109.48,-446 222.6,-893 310.85,-1343.7 13.21,-67.5 116.29,-38.9 103.11,28.4 -81.52,416.3 -185.4,829.2 -285.82,1241.4 -47.49,194.9 -86.55,393.8 -145.39,585.6 -42.95,140 -98.78,315.5 -231.72,395.8 -119.19,72.1 -278.39,56.4 -411.77,63.8 -210.98,11.6 -422.08,20.7 -633.14,30.6 -434.89,20.2 -869.7,42.1 -1304.65,60.8 -488.19,21 -976.58,37.9 -1465.19,44.5 -68.82,0.9 -68.86,-106 0,-106.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6382.78,6366.7 c -110.47,0 -215.46,-40.3 -290.69,-112.1 -72.47,-69.1 -112.35,-161.7 -112.35,-260.6 0,-217.5 191.5,-403.4 426.85,-414.4 118.78,-5.5 231.91,35.2 311.95,111.6 72.46,69.1 112.35,161.7 112.35,260.5 0,217.5 -191.45,403.4 -426.8,414.5 -7.1,0.3 -14.26,0.5 -21.31,0.5 z m 45.06,-841 c -7.88,0 -15.82,0.1 -23.75,0.5 -263.45,12.3 -477.82,222.1 -477.82,467.8 0,113.7 45.79,219.9 128.91,299.2 90.58,86.5 220.16,132.8 351.41,126.3 263.44,-12.3 477.76,-222.1 477.76,-467.8 0,-113.6 -45.79,-219.9 -128.9,-299.2 -85.15,-81.3 -203.46,-126.8 -327.61,-126.8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9071.55,5373.3 c 107.6,-5.1 215.43,-2.1 323.09,-5.6 26.32,-0.9 52.64,-2.1 78.9,-4 22.01,-1.7 44.58,-3.9 59.94,-6.4 17.76,-3 34.76,-7.3 51.91,-12.6 12.37,-3.8 -6.89,3.9 -0.31,0.3 1.67,-1 6.82,-2.4 7.6,-4.1 4.05,-8.8 -7.45,7.7 -3.07,2.6 -6.32,7.3 -7.21,7.5 -9.96,17.1 0.4,-1.3 0.98,23.9 -1.02,15.8 2.68,10.8 5.89,8.7 -0.63,1.5 -6.27,-6.9 7.76,8.6 2.93,3.6 -1.64,-1.7 -2.99,-3.7 -4.66,-5.4 -4.58,-4.6 -9.01,-9.3 -13.78,-13.7 -5.51,-5.1 -11.25,-10 -17.07,-14.8 -2.1,-1.7 -4.24,-3.4 -6.36,-5.1 -11.06,-8.9 9.01,6.6 -2.81,-2.1 -14.07,-10.5 -28.37,-20.6 -42.91,-30.4 -67.39,-45.3 -138.06,-85.8 -208.82,-125.6 -53.63,-30.1 -111.5,-56.8 -162.14,-91.9 -23.7,-16.4 -34.56,-46.9 -19.18,-73.1 13.72,-23.5 49.3,-35.8 73.14,-19.2 47.75,33.1 102.21,58.3 152.81,86.7 76.81,43 153.75,86.7 226.48,136.5 46.43,31.7 130.03,81.4 129.64,147 -0.57,93.6 -155.27,96.3 -218.55,100.7 -131.53,9.1 -263.55,2.8 -395.17,9.1 -68.79,3.3 -68.62,-103.6 0,-106.9",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11162.9,14287.1 c 2.6,326.6 118.2,643.4 256.7,935.2 130.9,275.6 282.1,547.9 452.3,801.2 301,447.8 753.6,901.6 1329,911.1 285.7,4.8 568.2,-98.8 754.4,-321.5 128.6,-153.8 197.3,-367.3 155.1,-566 -37.6,-177.3 -143.5,-331 -262.3,-464.2 -150.8,-168.9 -326,-314.9 -502.1,-456.5 -400.9,-322.5 -855.1,-626.7 -1136.5,-1067.9 -55.7,-87.3 83,-167.9 138.4,-81 263.8,413.6 696.1,703.6 1073.1,1004.7 185.7,148.2 371.2,300.2 530.9,476.7 138.1,152.6 263.9,330.1 310.6,533.8 125.3,546.3 -345.7,1017.5 -861.3,1089.1 -627.1,87.1 -1159.4,-308.6 -1524.9,-779.9 -218.1,-281.3 -396.9,-598.2 -555.1,-916.3 -169.8,-341.3 -315.6,-712.2 -318.7,-1098.5 -0.8,-103.3 159.6,-103.3 160.4,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8262.71,14496.4 c -49.31,997.5 69.16,2035.3 698.83,2849.1 257.81,333.2 663.61,694.3 1119.56,566.2 172,-48.3 318.7,-164.7 401.9,-323.1 99.5,-189.1 77.6,-394 15.5,-590.9 -167.3,-530.2 -530.15,-966.4 -800.57,-1444.3 -50.9,-89.9 87.6,-170.9 138.49,-80.9 260.28,459.9 595.38,878.2 780.78,1378 82.6,222.8 134.5,460.3 57.9,692.6 -63.4,192.3 -199.9,356.4 -378.1,452.8 -440.59,238.4 -927.57,15.7 -1252,-311.3 -373.56,-376.5 -632.17,-866.5 -778.05,-1373.4 -169.13,-587.6 -194.65,-1207.3 -164.62,-1814.8 5.08,-102.8 165.49,-103.4 160.38,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11562.8,15798 c -935,26.2 -1867.22,-209.1 -2667.6,-695.9 -754.95,-459.2 -1378.4,-1125.9 -1795.08,-1904.4 -420.7,-786 -631.33,-1682.3 -590.91,-2573.8 42.37,-934.3 324.43,-1929.2 1023.57,-2585.3 691.36,-648.7 1645.88,-939.4 2566.02,-1066.2 113.9,-15.7 228.1,-29.3 342.5,-40.6 102.7,-10.2 102,150.3 0,160.4 -896.31,88.7 -1832.19,311.7 -2563.06,863.7 -368.32,278.2 -662.68,643.8 -849.34,1066.3 -182.53,413.1 -291.11,870.7 -338.09,1319 -90.14,860 57.59,1739.3 421.92,2523.5 357.75,770.1 914.14,1447.4 1611.09,1934.2 729.97,510 1596.48,800.9 2486.08,836.9 117.6,4.7 235.3,5.1 352.9,1.8 103.2,-2.9 103.1,157.5 0,160.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13813.8,15300.9 c 636.1,-224.3 1198.2,-621.9 1646.2,-1123.8 451.3,-505.6 786,-1114.5 986.1,-1761.2 200.5,-648.1 270,-1342.7 173.1,-2015.7 -100.8,-700 -372.9,-1376.5 -852.4,-1903.4 -482.2,-530 -1125.5,-879.1 -1800.8,-1099.5 -89.2,-29.1 -179.1,-56 -269.5,-81.2 -99.2,-27.7 -57.1,-182.5 42.7,-154.7 716.1,200.1 1411.2,521.7 1957.5,1035.4 543.8,511.5 886.8,1189.8 1034.9,1917.5 141,692.3 112,1413.8 -61.5,2097.5 -173.8,685.2 -492.6,1332.5 -933.5,1885.2 -432.5,542.4 -991.6,989.1 -1631.4,1261.6 -81.9,34.9 -164.8,67.3 -248.7,97 -97.6,34.3 -139.5,-120.6 -42.7,-154.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20764.7,5379.7 c -231.1,0 -462.3,1.7 -693.4,3.8 -103.2,0.9 -103.3,-159.5 0,-160.4 231.1,-2.1 462.3,-3.7 693.4,-3.8 103.2,0 103.4,160.4 0,160.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10359.1,5299.1 c 986.2,-4.6 1972.3,-9.6 2958.5,-15.2 826.6,-4.7 1653.2,-9.7 2479.9,-16.4 323.1,-2.6 646.2,-5.4 969.4,-9.1 103.2,-1.2 103.3,159.1 0,160.3 -649.5,7.6 -1298.9,12 -1948.3,16.4 -920.5,6.1 -1840.9,11.3 -2761.4,16 -566,3 -1132.1,5.7 -1698.1,8.4 -103.2,0.5 -103.3,-159.9 0,-160.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4079.02,5323 c 242.06,0 484.12,-0.9 726.18,-1.7 103.21,-0.3 103.35,160.1 0,160.4 -242.06,0.8 -484.12,1.7 -726.18,1.7 -103.2,0 -103.37,-160.3 0,-160.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12538.5,7115.7 c -418.4,-107.1 -826.2,-251.6 -1235,-390 -207.1,-70.1 -414.5,-139.4 -623.8,-202.6 -102.3,-30.9 -205,-60.3 -308.4,-87.2 -96.7,-25.1 -194.8,-48.5 -283.5,-96 -298.37,-159.8 -329.83,-613.7 -16.5,-773 248.3,-126.2 568.6,-127.6 840,-102.4 200.1,18.5 398.6,59.3 598.1,84.5 233.8,29.7 468,56.2 701.6,87.8 43.2,5.9 65.9,60.9 56,98.7 -12.3,46.4 -56,61.8 -98.7,56 -378.9,-51.3 -759.4,-89.4 -1137,-150.5 -239.2,-38.7 -506.3,-43.8 -744.8,17.1 -96.4,24.6 -211.4,63.4 -255.7,161.1 -69.91,153.8 11.5,322.4 156.9,391.8 84,40.1 178.5,57.4 267.9,81.2 89.3,23.9 178.2,49.5 266.8,76.2 194,58.6 386.5,122.5 578.5,187.4 423.9,143.1 846.4,294.2 1280.2,405.2 100,25.6 57.6,180.3 -42.6,154.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9805.52,7158 c -185.3,-70.3 -363.77,-164.7 -539.98,-254.7 -104.91,-53.6 -209.33,-108.4 -311.33,-167.3 -65.44,-37.9 -138.75,-76.7 -192.47,-130.9 -72.73,-73.4 40.62,-186.9 113.41,-113.4 5.22,5.2 33.27,27.5 15.48,14.3 13.91,10.3 28.25,20.1 42.75,29.5 35.93,23.5 72.94,45.4 110.15,66.8 99.36,57.1 200.91,110.4 302.96,162.5 102.9,52.6 206.56,103.7 311.01,153.1 39.78,18.8 79.67,37.4 119.83,55.4 16.42,7.3 32.89,14.6 49.46,21.7 -20.21,-8.6 14.64,5.8 21.37,8.3 40.47,15.4 68.26,54.1 56.01,98.7 -10.66,38.8 -57.94,71.4 -98.65,56",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9762.67,6370.2 c 12.22,-231.1 27.17,-462.1 39.39,-693.2 2.28,-43.2 35.22,-80.2 80.19,-80.2 41.65,0 82.49,36.8 80.19,80.2 -12.22,231.1 -27.17,462.1 -39.38,693.2 -2.29,43.3 -35.22,80.2 -80.2,80.2 -41.65,0 -82.48,-36.7 -80.19,-80.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11083.2,9710.4 c -31.5,-54.6 -88.1,-89.7 -151.7,-89 -55.6,0.7 -110.1,24.6 -154.6,56.5 -52.1,37.4 -95.3,81.9 -132.1,134.4 -29.9,42.7 -55,93 -62.8,144.9 -9.4,63.5 2.9,127.5 52,172.8 46,42.3 108.4,55.7 168.3,38 53.4,-15.8 100.6,-50 140,-88.5 4.4,-4.2 8.5,-8.9 12.7,-13.4 20.8,-17.4 40.5,-36.2 57.9,-56.6 68.2,-79.8 129.4,-196.8 70.3,-299.1 m -602.5,-596 c -103.4,0 -103.2,160.4 0,160.4 103.3,0 103.2,-160.4 0,-160.4 m 742.3,802.9 c -155.2,374.7 -574.4,636.8 -963.3,370.7 -471.66,-322.7 -443.64,-1143 93.5,-1376 235.9,-102.4 533.6,-55.8 714.3,130.9 214.8,222 276.2,583.1 155.5,874.4",
    style: {
      fill: "#99413c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8141.79,9670.9 c -36.08,-76.6 -127.34,-113.8 -208.07,-104.2 -143.67,17 -319.32,123.4 -367.14,265.4 -56.42,167.4 45.38,393.4 248.1,327.7 68.91,-22.4 129.84,-64 183.56,-111.8 99.41,-88.4 208.27,-239.6 143.55,-377.1 m -434.61,-560.7 -0.03,0.1 c 3.35,-10.7 3.81,-21.3 1.44,-32 -0.47,-3.5 -0.96,-7.1 -1.44,-10.6 l -8.09,-19.2 c -4.17,-5.4 -8.35,-10.8 -12.53,-16.2 l -16.23,-12.6 c -18.54,-10.8 -41.12,-13.8 -61.82,-8 -1.8,0.4 -13.52,4.3 -19.34,8.1 l -1.15,0.8 c -1.57,1.1 -3.11,2.3 -4.62,3.5 -10.24,7.6 -20.42,15.4 -30.31,23.5 -4.38,3.6 -8.82,7.2 -12.68,11.3 l -1,1.2 -0.42,0.4 -0.18,0.3 c -3,3.7 -9.84,12.5 -12.66,16.4 -4.36,6 -7.54,15.4 -9.01,20.7 -1.95,7 -2.97,14.5 -2.94,21.8 0,7.2 0.65,14.7 2.89,21.5 0.45,1.4 7.47,18 8.15,19.3 4.1,5.5 8.3,10.9 12.55,16.3 h 0.03 0.03 l 16.31,12.6 c 1.07,0.7 18.12,7.8 19.32,8.2 6.99,2.3 14.59,2.9 21.95,2.9 14.47,0 27.96,-3.6 40.46,-10.9 l 16.24,-12.5 c 3.08,-3.2 5.35,-6.8 7.83,-10.2 3.16,-2.8 6.42,-5.5 9.72,-8.1 4.82,-3.7 9.65,-7.4 14.45,-11.1 l 1.86,-1.5 0.42,-0.4 c 10.41,-9 12.14,-15.1 16.73,-25.9 1.54,-3.7 2.66,-6.4 4.07,-9.7 -0.25,0.9 6.06,-14 12.33,-28.9 12.21,-28.9 24.29,-57.8 -12.33,28.9 m 554.27,685 c -122.74,322.5 -529.26,633.7 -883.35,428.4 -378.63,-219.5 -318.24,-828.6 -112.58,-1144.7 103.84,-159.6 257.21,-301.5 458.29,-306.2 51.82,-1.3 100.79,6 146.68,19.6 36.2,6.9 72.67,16.8 109.37,32.9 366.43,160.2 407.8,638.3 281.59,970",
    style: {
      fill: "#99413c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7419.11,8104.9 c -127.82,0 -255.46,19.1 -376.76,58.5 -259.79,84.3 -485.29,250.4 -657.37,462.6 -154.4,190.5 -265.79,418.1 -320.35,657 -132.75,581.4 32.93,1285.4 440.79,1661.1 -2.29,-106.7 -1.05,-213.4 3.79,-320.2 40.95,-903 305.78,-1862.6 954.67,-2518.2 -14.93,-0.5 -29.83,-0.8 -44.77,-0.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(247, 245, 186)"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8102.88,8551.6 c -148.92,128.9 -343.13,206.9 -555.53,206.9 -99.67,0 -195.05,-17.7 -283.77,-49.4 -10.38,8.6 -23.45,12.4 -36.6,12.4 -12.5,0 -25.09,-3.5 -35.54,-9.8 -60.76,99.5 -115.13,203.2 -162.54,310.5 -182.53,413.1 -291.11,870.7 -338.09,1319 -25.38,242.1 -31.9,485.7 -20.05,728.3 146.88,89.8 316.89,141.6 508.4,141.6 133.8,0 277.92,-25.2 432.08,-80.6 641.29,-230.4 1045.48,-1035.5 1026.73,-1759.1 -6.88,-6.8 -13.36,-14.8 -19.31,-23.8 -168.34,-255.6 -199.07,-549 -457.65,-753.5 -18.96,-15 -38.35,-29.2 -58.13,-42.5 m -483.73,1737.9 c -80.48,0 -162.06,-20.1 -241.05,-65.9 -378.63,-219.5 -318.24,-828.6 -112.58,-1144.7 103.84,-159.6 257.21,-301.5 458.29,-306.2 3.81,-0.1 7.6,-0.2 11.38,-0.2 47.62,0 92.78,7.2 135.3,19.8 36.2,6.9 72.67,16.8 109.37,32.9 366.43,160.2 407.8,638.3 281.59,970 -95.36,250.5 -362.03,494.3 -642.3,494.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8237.93,8403.7 c -39.09,54.5 -84.44,104.1 -135.05,147.9 19.78,13.3 39.17,27.5 58.13,42.5 258.58,204.5 289.31,497.9 457.65,753.5 5.95,9 12.43,17 19.31,23.8 -7.21,-278 -76.86,-544 -219.5,-760.7 -50.96,-77.4 -111.94,-146.5 -180.54,-207 m -1030.94,282.9 c -5.23,8.3 -10.41,16.7 -15.55,25.1 10.45,6.3 23.04,9.8 35.54,9.8 13.15,0 26.22,-3.8 36.6,-12.4 -19.18,-6.9 -38.05,-14.4 -56.59,-22.5",
    style: {
      fill: "#fde9e1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7670.26,8129.5 c -178.58,164.5 -334.65,351.7 -463.27,557.1 18.54,8.1 37.41,15.6 56.59,22.5 88.72,31.7 184.1,49.4 283.77,49.4 212.4,0 406.61,-78 555.53,-206.9 50.61,-43.8 95.96,-93.4 135.05,-147.9 -158.4,-139.5 -357.44,-232.7 -567.67,-274.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(253, 211, 237)"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7463.88,8105.7 c -648.89,655.6 -913.72,1615.2 -954.67,2518.2 -4.84,106.8 -6.08,213.5 -3.79,320.2 51.29,47.3 106.49,89.4 165.34,125.4 -11.85,-242.6 -5.33,-486.2 20.05,-728.3 46.98,-448.3 155.56,-905.9 338.09,-1319 47.41,-107.3 101.78,-211 162.54,-310.5 5.14,-8.4 10.32,-16.8 15.55,-25.1 128.62,-205.4 284.69,-392.6 463.27,-557.1 -67.94,-13.4 -137.11,-21.4 -206.38,-23.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7629.68,9008.8 c -7.13,0 -14.27,0.9 -21.2,2.9 -1.8,0.4 -13.52,4.3 -19.34,8.1 l -1.15,0.8 c -1.57,1.1 -3.11,2.3 -4.62,3.5 -10.24,7.6 -20.42,15.4 -30.31,23.5 -4.38,3.6 -8.82,7.2 -12.68,11.3 l -1,1.2 -0.42,0.4 -0.18,0.3 c -3,3.7 -9.84,12.5 -12.66,16.4 -4.36,6 -7.54,15.4 -9.01,20.7 -1.95,7 -2.97,14.5 -2.94,21.8 0,7.2 0.65,14.7 2.89,21.5 0.45,1.4 7.47,18 8.15,19.3 4.1,5.5 8.3,10.9 12.55,16.3 h 0.03 0.03 l 16.31,12.6 c 1.07,0.7 18.12,7.8 19.32,8.2 6.99,2.3 14.59,2.9 21.95,2.9 14.47,0 27.96,-3.6 40.46,-10.9 l 16.24,-12.5 c 3.08,-3.2 5.35,-6.8 7.83,-10.2 3.16,-2.8 6.42,-5.5 9.72,-8.1 4.82,-3.7 9.65,-7.4 14.45,-11.1 l 1.86,-1.5 0.42,-0.4 c 10.41,-9 12.14,-15.1 16.73,-25.9 1.54,-3.7 2.66,-6.4 4.07,-9.7 v 0 l -0.03,0.1 c 3.35,-10.7 3.81,-21.3 1.44,-32 -0.47,-3.5 -0.96,-7.1 -1.44,-10.6 l -8.09,-19.2 c -4.17,-5.4 -8.35,-10.8 -12.53,-16.2 l -16.23,-12.6 c -12.33,-7.2 -26.45,-10.9 -40.62,-10.9 m 101.98,43.6 c -0.04,0 -6.17,14.5 -24.48,57.8 v 0 0 c 0,0.1 0,0.1 0,0.1 0.1,0 6.23,-14.5 12.33,-29 6.11,-14.4 12.18,-28.9 12.15,-28.9 m 227.32,512.8 c -8.49,0 -16.93,0.5 -25.26,1.5 -143.67,17 -319.32,123.4 -367.14,265.4 -49.56,147.1 22.98,339.4 178.75,339.4 21.56,0 44.7,-3.7 69.35,-11.7 68.91,-22.4 129.84,-64 183.56,-111.8 99.41,-88.4 208.27,-239.6 143.55,-377.1 -32.35,-68.7 -109.09,-105.7 -182.81,-105.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7735.19,8772.5 c -3.78,0 -7.57,0.1 -11.38,0.2 -201.08,4.7 -354.45,146.6 -458.29,306.2 -205.66,316.1 -266.05,925.2 112.58,1144.7 78.99,45.8 160.57,65.9 241.05,65.9 280.27,0 546.94,-243.8 642.3,-494.3 126.21,-331.7 84.84,-809.8 -281.59,-970 -36.7,-16.1 -73.17,-26 -109.37,-32.9 -42.52,-12.6 -87.68,-19.8 -135.3,-19.8 m -139.79,428 c -7.36,0 -14.96,-0.6 -21.95,-2.9 -1.2,-0.4 -18.25,-7.5 -19.32,-8.2 l -16.31,-12.6 h -0.03 -0.03 c -4.25,-5.4 -8.45,-10.8 -12.55,-16.3 -0.68,-1.3 -7.7,-17.9 -8.15,-19.3 -2.24,-6.8 -2.89,-14.3 -2.89,-21.5 -0.03,-7.3 0.99,-14.8 2.94,-21.8 1.47,-5.3 4.65,-14.7 9.01,-20.7 2.82,-3.9 9.66,-12.7 12.66,-16.4 l 0.18,-0.3 0.42,-0.4 1,-1.2 c 3.86,-4.1 8.3,-7.7 12.68,-11.3 9.89,-8.1 20.07,-15.9 30.31,-23.5 1.51,-1.2 3.05,-2.4 4.62,-3.5 l 1.15,-0.8 c 5.82,-3.8 17.54,-7.7 19.34,-8.1 6.93,-2 14.07,-2.9 21.2,-2.9 14.17,0 28.29,3.7 40.62,10.9 l 16.23,12.6 c 4.18,5.4 8.36,10.8 12.53,16.2 l 8.09,19.2 c 0.48,3.5 0.97,7.1 1.44,10.6 2.37,10.7 1.91,21.3 -1.44,32 l 0.03,-0.1 v 0 0 c 18.31,-43.3 24.44,-57.8 24.48,-57.8 0.03,0 -6.04,14.5 -12.15,28.9 -6.1,14.5 -12.23,29 -12.33,29 0,0 0,0 0,-0.1 -1.41,3.3 -2.53,6 -4.07,9.7 -4.59,10.8 -6.32,16.9 -16.73,25.9 l -0.42,0.4 -1.86,1.5 c -4.8,3.7 -9.63,7.4 -14.45,11.1 -3.3,2.6 -6.56,5.3 -9.72,8.1 -2.48,3.4 -4.75,7 -7.83,10.2 l -16.24,12.5 c -12.5,7.3 -25.99,10.9 -40.46,10.9 m 149.93,971 c -155.77,0 -228.31,-192.3 -178.75,-339.4 47.82,-142 223.47,-248.4 367.14,-265.4 8.33,-1 16.77,-1.5 25.26,-1.5 73.72,0 150.46,37 182.81,105.7 64.72,137.5 -44.14,288.7 -143.55,377.1 -53.72,47.8 -114.65,89.4 -183.56,111.8 -24.65,8 -47.79,11.7 -69.35,11.7 m -38.15,-1061.3 v 0 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10685.5,8396.1 c -156.7,0 -316.4,28.6 -476.6,92.5 -770.15,306.9 -979.44,1227.5 -780.51,1958.3 19.47,71.6 -37.31,117.9 -93.84,117.9 -12.16,0 -24.33,-2.2 -35.71,-6.7 240.56,573 783.06,983.9 1485.76,983.9 43.7,0 87.8,-1.6 132.7,-4.8 1055.3,-75.9 1694.1,-1129.3 1480.3,-2105.5 -81.2,25.8 -167.8,39.8 -257.7,39.8 -469,0 -849.3,-380.3 -849.3,-849.3 0,-29.5 1.5,-58.7 4.5,-87.5 -193.6,-86.9 -398.9,-138.6 -609.6,-138.6 m -94.4,2000.3 c -108.4,0 -221.1,-33 -331.4,-108.4 -471.66,-322.7 -443.64,-1143 93.5,-1376 81.9,-35.6 171.3,-53.2 260.6,-53.2 167.9,0 335.7,62.2 453.7,184.1 214.8,222 276.2,583.1 155.5,874.4 -111.2,268.4 -357.9,479.1 -631.9,479.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10737.4,8176.2 c -86.1,0 -171,6 -253.5,18 -611.63,89.2 -1069.18,511.4 -1251.62,1173.4 -115.63,419.6 -82.25,836.1 66.56,1190.5 11.38,4.5 23.55,6.7 35.71,6.7 56.53,0 113.31,-46.3 93.84,-117.9 -198.93,-730.8 10.36,-1651.4 780.51,-1958.3 160.2,-63.9 319.9,-92.5 476.6,-92.5 210.7,0 416,51.7 609.6,138.6 9.1,-89 31.9,-173.9 66.3,-252.6 -202.9,-70.9 -416.8,-105.9 -624,-105.9",
    style: {
      fill: "#fde9e1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11361.4,8282.1 c -34.4,78.7 -57.2,163.6 -66.3,252.6 -3,28.8 -4.5,58 -4.5,87.5 0,469 380.3,849.3 849.3,849.3 89.9,0 176.5,-14 257.7,-39.8 -20.2,-92.4 -48.1,-184.2 -84,-274.4 -176.1,-442.3 -541.8,-732 -952.2,-875.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(253, 211, 237)"
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10480.7,9114.4 c -103.4,0 -103.2,160.4 0,160.4 103.3,0 103.2,-160.4 0,-160.4 m 452.7,507 c -0.6,0 -1.3,0 -1.9,0 -55.6,0.7 -110.1,24.6 -154.6,56.5 -52.1,37.4 -95.3,81.9 -132.1,134.4 -29.9,42.7 -55,93 -62.8,144.9 -9.4,63.5 2.9,127.5 52,172.8 32.8,30.1 73.9,45.6 116.5,45.6 17.2,0 34.6,-2.5 51.8,-7.6 53.4,-15.8 100.6,-50 140,-88.5 4.4,-4.2 8.5,-8.9 12.7,-13.4 20.8,-17.4 40.5,-36.2 57.9,-56.6 68.2,-79.8 129.4,-196.8 70.3,-299.1 -31.2,-54.1 -87,-89 -149.8,-89",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10613.8,8858.8 c -89.3,0 -178.7,17.6 -260.6,53.2 -537.14,233 -565.16,1053.3 -93.5,1376 110.3,75.4 223,108.4 331.4,108.4 274,0 520.7,-210.7 631.9,-479.1 120.7,-291.3 59.3,-652.4 -155.5,-874.4 -118,-121.9 -285.8,-184.1 -453.7,-184.1 m -133.1,416 c -103.2,0 -103.4,-160.4 0,-160.4 103.2,0 103.3,160.4 0,160.4 m 269.8,900.8 c -42.6,0 -83.7,-15.5 -116.5,-45.6 -49.1,-45.3 -61.4,-109.3 -52,-172.8 7.8,-51.9 32.9,-102.2 62.8,-144.9 36.8,-52.5 80,-97 132.1,-134.4 44.5,-31.9 99,-55.8 154.6,-56.5 0.6,0 1.3,0 1.9,0 62.8,0 118.6,34.9 149.8,89 59.1,102.3 -2.1,219.3 -70.3,299.1 -17.4,20.4 -37.1,39.2 -57.9,56.6 -4.2,4.5 -8.3,9.2 -12.7,13.4 -39.4,38.5 -86.6,72.7 -140,88.5 -17.2,5.1 -34.6,7.6 -51.8,7.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8748.23,9354.6 c 34.71,8.6 69.69,15.9 105.01,21.6 8.14,1.3 16.3,2.6 24.47,3.7 -13.89,-1.9 12.6,1.5 15.51,1.8 17.77,2 35.57,3.5 53.41,4.7 71.41,4.8 143.01,3.2 214.19,-4.2 41.86,-4.3 81.99,40 80.19,80.2 -2.11,47.2 -35.35,75.5 -80.19,80.2 -152.19,15.8 -306.8,3.5 -455.22,-33.4 -40.73,-10.1 -69.12,-58.1 -56.01,-98.6 13.65,-42.2 55,-66.9 98.64,-56",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8538.45,9191 c -125.72,-423.8 -409.71,-770.8 -863.64,-851.5 -432.75,-76.9 -861.77,125.3 -1114.15,476.6 -254.13,353.7 -345.02,810.1 -271.49,1237.3 70.83,411.3 322.06,925.9 774.94,1012.6 38.84,7.4 30.83,59.8 -7.34,59.7 -489.4,-1 -766.89,-448.2 -883.21,-876.6 -143.34,-527.9 -60.38,-1124.4 275.32,-1564.4 297.28,-389.6 765.01,-593.6 1250.94,-478.1 458.37,108.9 826.49,503.5 880.03,973.2 2.64,23.3 -34.17,35.6 -41.4,11.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11063.7,8411.8 c -797,-279.7 -1475.84,404.6 -1636.77,1142.4 -163.6,749.8 256.61,1327.3 821.37,1767.1 30.8,23.9 -3.6,69.4 -35.8,48.3 -708.51,-463.4 -1128.48,-1162.5 -860.8,-2022.4 221.28,-711 967.8,-1394 1741.2,-1008.8 45.1,22.5 19.3,90.4 -29.2,73.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6455.86,8696.9 c -371.33,464.8 -421.34,1112.3 -216.86,1658.8 81.34,217.4 213.29,426 398.15,569.7 185.06,143.9 412.8,202 644.69,180.6 539.33,-49.7 933.66,-482.2 1118.58,-964.6 180.27,-470.1 218.25,-1062.9 -78.95,-1495.6 -171.58,-249.9 -471.93,-403 -769.72,-433.7 -332.35,-34.3 -657.12,72.8 -909.39,291.7 -67.81,58.8 -129.51,123.8 -186.5,193.1 -34.65,42.2 -105.73,35.3 -141.76,0 -41.82,-40.9 -34.19,-100.2 0,-141.7 246.58,-300 595.08,-507.8 984.66,-544.8 346.07,-32.8 701.87,73.2 972.47,290.8 489.72,394 544.19,1114.8 391.27,1682.2 -153.58,569.8 -539.91,1112.4 -1129.58,1277.3 -282.99,79.1 -584.92,66.6 -848.68,-68.7 -236.97,-121.5 -420.96,-333.5 -543.04,-567.1 -288.19,-551.4 -305.33,-1262.1 -3.16,-1810.8 50.6,-91.9 110.66,-177.1 176.06,-258.9 34.06,-42.7 106.12,-34.9 141.76,0 42.26,41.3 33.6,99.7 0,141.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10510.5,8290.9 c -325.7,49.3 -619.45,197.5 -839,445.2 -227.09,256.2 -361.91,602.5 -397.91,941 -67.96,639 222.5,1291.8 803.01,1596.4 577,302.8 1319,191.5 1778.3,-269.1 440.7,-442 592.7,-1122.8 400.5,-1713.9 -210.7,-648.2 -865.3,-1016.9 -1525.7,-1014.1 -73.1,0.3 -146.8,4.3 -219.2,14.5 -54,7.6 -107,-13.2 -123.3,-70 -13.4,-46.9 16.5,-115.8 70,-123.3 714.6,-100.7 1509.1,195.8 1867.6,849 341.1,621.6 264.7,1438.3 -158.5,2001.5 -210.9,280.7 -495.5,496 -829.7,607.8 -350.9,117.5 -751.6,116.5 -1102.7,0.2 -693.46,-229.6 -1141.99,-890.9 -1169.91,-1611.1 -29.25,-754.7 385.67,-1536.5 1125.51,-1784 87.3,-29.2 176.8,-49.7 267.7,-63.4 53.9,-8.2 107.2,13.6 123.3,70 13.6,47.3 -16.5,115.2 -70,123.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8932.67,8672.6 c 2.18,28.5 4.22,56.9 6.76,85.4 1.25,13.9 2.62,27.9 4.19,41.8 0.73,6.5 1.65,12.9 2.34,19.4 -2.8,-26.4 0.15,0.5 1.19,7 3.89,24.6 8.78,49 16.22,72.7 1.57,5 3.24,10 5.07,14.9 7.3,19.4 -7.75,-14.7 -0.17,-0.6 2.17,4 4.12,8.1 6.48,12 1.39,2.3 2.99,4.5 4.38,6.9 6.06,10.1 -12.23,-13.7 -5.95,-7.6 2.7,2.6 5.73,5.6 8.21,8.4 5.77,6.6 -19.08,-11.8 -8.44,-6.5 1.43,0.7 3.56,2 4.74,2.9 8.65,6.5 -22.11,-7 -6.43,-2.8 16.51,4.3 -21.99,0.1 -4.23,-0.6 17.76,-0.7 -16.35,2.9 -5.49,1.2 3.55,-0.5 7.11,-0.9 10.66,-1.4 10.66,-2.4 21.32,-1.9 31.97,1.4 9.81,-1.1 -11.36,0.4 -12.34,-1.5 l 5.92,0.2 c 10.85,-1 -13.07,1.6 -12.53,2.1 2.31,1.7 11.91,-3.7 14.41,-4 -17.97,2.2 -15.47,7.3 -5.05,1 1.88,-1.2 3.66,-2.5 5.55,-3.7 11.47,-6.7 -13.67,11.9 -6.63,5.2 8.33,-7.8 16.52,-15.4 23.99,-24.1 1.75,-2.1 3.4,-4.3 5.18,-6.3 6.39,-7.4 -10.48,14.4 -4.85,6.3 3.72,-5.4 7.66,-10.6 11.32,-16 7.7,-11.4 14.91,-23.1 21.83,-35 30.14,-51.8 54.45,-106.7 81.91,-159.9 19.26,-37.4 74.64,-51.4 109.72,-28.8 38.08,24.6 49.37,69.8 28.77,109.7 -33.37,64.7 -61.9,132.4 -102.51,193.1 -47.97,71.7 -114.29,135.1 -207.32,116.4 14.21,0 28.43,0 42.63,0 -218.79,39.7 -221.01,-267.3 -231.88,-409.2 -3.21,-41.9 39.18,-82 80.19,-80.2 46.2,2.1 76.75,35.3 80.19,80.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9190.23,5630.4 c 198.16,61.8 404.15,92.9 602.31,154.7 41.34,12.8 67.76,55.9 56,98.6 -11.21,40.8 -57.13,69 -98.64,56 -198.16,-61.7 -404.14,-92.9 -602.3,-154.6 -41.35,-12.9 -67.76,-55.9 -56.01,-98.6 11.21,-40.8 57.13,-69 98.64,-56.1",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14591.3,7474.6 c 348.9,-5.5 686.5,-154.2 931.1,-402.6 260.1,-264.1 385,-628.7 362.3,-997 -13.2,-213.9 -79.1,-421.2 -190.3,-604.2 -53.7,-88.4 84.9,-169.1 138.5,-80.9 218.4,359.3 273.4,809.8 150.7,1212.1 -116,380.5 -393.7,697.7 -748.9,874.6 -200.5,99.8 -419.4,154.9 -643.4,158.4 -103.3,1.6 -103.3,-158.8 0,-160.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20326.8,6175.8 c 186.8,-140.6 79.9,-411.5 -38.3,-555.5 -145.3,-177.2 -336.4,-320.5 -534.1,-434.1 -331.5,-190.4 -704.5,-264.5 -1081.6,-297.4 -637.8,-55.5 -1460.7,0.7 -1886.8,551.2 -223.8,289 -306.7,676.4 -293.3,1035.5 14.1,378.1 137.2,753.3 354.9,1063.1 439.6,625.5 1271.4,830.3 1993.1,672.2 366.3,-80.3 710.2,-254.4 964.3,-533.6 294.7,-323.8 463.9,-757.7 466.4,-1195.4 0.7,-109 -8.8,-217.4 -28.8,-324.7 -18.8,-100.9 135.7,-144.1 154.6,-42.6 87.8,471.2 -2.6,964 -252.2,1373.7 -228.3,374.9 -572.5,647.1 -983.5,796.8 -757.7,275.8 -1722.9,147.3 -2287.6,-460.8 -558.7,-601.8 -725.7,-1590.8 -321.5,-2319.1 382.5,-689.1 1270.6,-825.7 1986.9,-786.2 396.2,21.9 806.1,82.9 1165.1,259.1 226.7,111.3 439.9,260.7 617.4,440.8 164.9,167.2 302.9,385.7 255,630.1 -21.4,109 -81,199.1 -169.1,265.4 -82.4,62.1 -162.5,-77.1 -80.9,-138.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17525.8,6771.5 c 46.7,0 93.5,0 140.2,0 20.6,0 42.2,8.9 56.7,23.5 14,13.9 24.4,36.7 23.5,56.7 -0.9,20.7 -7.7,42.2 -23.5,56.7 -15.6,14.4 -34.9,23.5 -56.7,23.5 -46.7,0 -93.5,0 -140.2,0 -20.6,0 -42.2,-9 -56.7,-23.5 -13.9,-13.9 -24.4,-36.7 -23.5,-56.7 0.9,-20.8 7.7,-42.3 23.5,-56.7 15.7,-14.4 34.9,-23.5 56.7,-23.5",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16927.3,7028.5 c 10.1,22.8 22,44.7 37,64.7 -4.1,-5.4 -8.3,-10.8 -12.5,-16.2 8.9,11.4 18.5,21.8 29.9,30.8 -5.4,-4.2 -10.8,-8.4 -16.2,-12.6 6.2,4.7 12.7,8.7 19.8,12 -6.4,-2.7 -12.8,-5.4 -19.2,-8.1 7,3 14,4.9 21.5,6 -7.1,-1 -14.2,-2 -21.3,-2.9 5.5,0.5 10.8,0.4 16.2,-0.2 -7.1,1 -14.2,2 -21.3,2.9 6.2,-1 11.9,-2.5 17.8,-4.7 -6.4,2.7 -12.8,5.4 -19.2,8.1 7.5,-3.3 14.2,-7.5 20.7,-12.5 -5.4,4.2 -10.8,8.4 -16.2,12.6 6.8,-5.7 12.9,-12 18.4,-18.9 -4.1,5.4 -8.3,10.8 -12.5,16.2 6.1,-8 11.2,-16.6 15.4,-25.8 -2.7,6.4 -5.4,12.8 -8.1,19.1 4.7,-11.1 7.8,-22.6 9.6,-34.5 -0.9,7.1 -1.9,14.2 -2.9,21.3 1.9,-14.1 1.8,-28.2 -0.1,-42.3 1,7.1 2,14.2 2.9,21.3 -2.1,-14.2 -5.9,-27.8 -11.4,-41.1 2.7,6.4 5.4,12.8 8.1,19.2 -5.3,-12.1 -11.8,-23.4 -19.8,-34 4.2,5.4 8.3,10.8 12.5,16.3 -6.8,-8.7 -14.5,-16.5 -23.1,-23.5 5.4,4.2 10.8,8.4 16.2,12.6 -8.8,-6.8 -18.2,-12.4 -28.4,-16.8 6.4,2.7 12.8,5.4 19.2,8.1 -9.3,-3.7 -18.8,-6.2 -28.6,-7.7 7.1,0.9 14.2,1.9 21.3,2.9 -11.3,-1.4 -22.4,-1.4 -33.6,0 7.1,-1 14.2,-1.9 21.3,-2.9 -12.4,1.8 -24.3,5.1 -35.9,9.8 6.4,-2.7 12.8,-5.4 19.2,-8.1 -12.7,5.5 -24.4,12.3 -35.5,20.6 5.4,-4.2 10.8,-8.3 16.2,-12.5 -10.9,8.5 -20.5,18.1 -29.2,28.9 4.2,-5.4 8.4,-10.9 12.6,-16.3 -7.6,10 -14,20.6 -19.1,32 2.7,-6.3 5.4,-12.7 8.1,-19.1 -4.3,10.5 -7.4,21.1 -9.2,32.3 1,-7.1 2,-14.2 2.9,-21.3 -1.3,10.3 -1.4,20.4 -0.3,30.7 -1,-7.1 -1.9,-14.2 -2.9,-21.3 1.5,10.5 4.1,20.6 8,30.4 -2.7,-6.4 -5.4,-12.7 -8.1,-19.1 4.6,10.9 10.4,20.9 17.4,30.4 -4.1,-5.4 -8.3,-10.8 -12.5,-16.2 8,10.2 17,19.3 27.3,27.3 -5.4,-4.2 -10.8,-8.4 -16.2,-12.5 9.4,7 19.3,12.8 30.1,17.5 -6.4,-2.7 -12.8,-5.4 -19.2,-8.1 9.7,3.9 19.5,6.7 29.7,8.3 -7.1,-1 -14.2,-1.9 -21.3,-2.9 10.3,1.3 20.5,1.4 30.8,0 -7.1,0.9 -14.3,1.9 -21.4,2.9 7.7,-1.3 14.9,-3.2 22.1,-6 -6.4,2.7 -12.8,5.4 -19.2,8.1 8.2,-3.5 15.7,-8 22.8,-13.4 -5.4,4.2 -10.9,8.4 -16.3,12.6 6.9,-5.7 13,-12 18.5,-19 -4.2,5.4 -8.4,10.8 -12.6,16.2 6,-8 10.9,-16.5 14.9,-25.6 -2.7,6.4 -5.4,12.8 -8.1,19.1 4.2,-10.1 7.1,-20.5 8.8,-31.4 -1,7.1 -1.9,14.2 -2.9,21.4 1.2,-9.8 1.4,-19.4 0.4,-29.2 0.9,7.1 1.9,14.2 2.8,21.3 -1.1,-8.6 -3.2,-16.8 -6.4,-24.8 2.7,6.3 5.4,12.7 8.1,19.1 -3.1,-7.1 -6.8,-13.6 -11.5,-19.7 4.2,5.4 8.4,10.8 12.6,16.2 -4,-4.9 -8.4,-9.2 -13.2,-13.3 5.4,4.2 10.8,8.4 16.2,12.5 -5.4,-4.1 -10.9,-7.5 -17.2,-10.3 6.4,2.7 12.8,5.4 19.2,8.1 -3.5,-1.3 -6.7,-2.2 -10.4,-2.9 7.1,1 14.2,1.9 21.3,2.9 -4.5,-0.5 -8.7,-0.5 -13.3,0.1 7.1,-1 14.3,-2 21.4,-2.9 -4.5,0.8 -8.6,2.1 -12.8,3.8 6.4,-2.7 12.8,-5.4 19.1,-8.1 -4.1,1.9 -7.9,4.2 -11.6,6.8 5.4,-4.1 10.8,-8.3 16.2,-12.5 -4.5,3.6 -8.4,7.5 -12,12 4.2,-5.4 8.4,-10.8 12.5,-16.2 -2.6,3.7 -4.8,7.4 -6.8,11.6 2.7,-6.4 5.4,-12.8 8.1,-19.2 -1.7,4.2 -2.9,8.3 -3.7,12.8 1,-7.1 1.9,-14.2 2.9,-21.3 -0.5,4.5 -0.4,8.7 0.1,13.3 -0.9,-7.1 -1.9,-14.2 -2.8,-21.3 0.6,3.1 1.4,5.9 2.5,8.9 -2.7,-6.4 -5.4,-12.8 -8.1,-19.2 1.6,3.6 3.5,6.8 5.8,10 -4.2,-5.4 -8.4,-10.8 -12.6,-16.2 3.1,3.8 6.5,7 10.3,10 -5.4,-4.2 -10.8,-8.4 -16.2,-12.5 4.1,2.8 8.2,5.1 12.8,7 -6.4,-2.7 -12.8,-5.4 -19.2,-8.1 4.7,1.8 9.3,3 14.2,3.8 -7.1,-1 -14.2,-1.9 -21.3,-2.9 4.9,0.6 9.7,0.7 14.6,0.3 -7.1,0.9 -14.2,1.9 -21.3,2.8 4.9,-0.7 9.3,-1.8 13.9,-3.6 -6.4,2.7 -12.8,5.4 -19.1,8.1 3.5,-1.6 6.7,-3.5 9.9,-5.8 -5.4,4.2 -10.9,8.3 -16.3,12.5 1.6,-1.2 3,-2.5 4.4,-3.9 30.2,-29.2 83.8,-32.3 113.4,0 29,31.6 32.2,82.3 0,113.4 -35.2,34 -88.5,46.6 -135,30 -52.6,-18.8 -92.4,-65.2 -90.7,-123.3 1.6,-57.8 42.5,-107.3 96.5,-125.2 50.7,-16.7 108.2,4.3 141.7,44.6 51.2,61.6 54.8,150 13.1,218.2 -43.7,71.4 -130.5,106.6 -211.2,80.3 -85.2,-27.8 -146.6,-103.8 -152,-193.6 -4.9,-79.8 46.1,-155.7 112.2,-196 65.9,-40.1 156,-45.8 221.5,-1.5 62.7,42.4 97.9,110.3 102.6,185.1 2.4,39.7 -7.7,81.3 -27.1,116 -23.5,42 -66.4,79.6 -114.9,88 -56.5,9.7 -108.2,-9.8 -148.6,-49.9 -28.4,-28.2 -50.3,-63.8 -66.4,-100.2 -9,-20.4 -14.2,-39.4 -8.1,-61.8 5.1,-18.6 19.5,-38.8 36.9,-47.9 18.6,-9.9 41.1,-14.8 61.8,-8.1 18.5,6 39.6,18.2 47.9,36.8",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18409.7,7052.3 c -0.7,2.6 -1.2,5 -1.6,7.6 1,-7.1 1.9,-14.2 2.9,-21.3 -0.2,2.5 -0.2,4.8 0,7.3 -1,-7.1 -1.9,-14.2 -2.9,-21.3 0.6,3.9 1.5,7.5 3.1,11.2 -2.7,-6.4 -5.4,-12.8 -8.1,-19.1 1.4,2.8 2.9,5.4 4.8,8 -4.2,-5.4 -8.4,-10.8 -12.5,-16.2 3.1,3.9 6.5,7.2 10.4,10.2 -5.4,-4.1 -10.8,-8.3 -16.2,-12.5 4.2,3 8.6,5.6 13.4,7.7 -6.4,-2.7 -12.8,-5.3 -19.2,-8 6.7,2.7 13.4,4.6 20.6,5.7 -7.1,-1 -14.2,-2 -21.3,-2.9 6.3,0.7 12.4,0.7 18.7,0 -7.1,0.9 -14.2,1.9 -21.4,2.9 5.3,-0.9 10.3,-2.2 15.2,-4.2 -6.4,2.7 -12.7,5.4 -19.1,8.1 4,-1.9 7.7,-4.1 11.2,-6.8 -5.4,4.2 -10.8,8.4 -16.2,12.5 4.1,-3.4 7.5,-7.3 10.8,-11.4 -4.1,5.4 -8.3,10.8 -12.5,16.2 4,-5.6 7.3,-11.4 10,-17.8 -2.7,6.4 -5.4,12.8 -8.1,19.2 2.9,-7.6 4.7,-15.1 5.9,-23.1 -1,7.1 -1.9,14.2 -2.9,21.3 1.2,-10.6 0.9,-21.1 -0.4,-31.8 1,7.1 1.9,14.2 2.9,21.4 -2.2,-14.6 -6.3,-28.5 -11.9,-42 2.6,6.4 5.3,12.8 8,19.2 -5.6,-12.6 -12.5,-24.4 -20.7,-35.4 4.2,5.4 8.4,10.8 12.5,16.2 -7.1,-9.2 -15,-17.5 -24.1,-24.8 5.4,4.2 10.8,8.3 16.2,12.5 -6,-4.5 -12.3,-8.4 -19.2,-11.6 6.4,2.7 12.8,5.4 19.2,8.1 -7,-3 -13.9,-5 -21.4,-6.1 7.1,1 14.2,1.9 21.3,2.9 -5.5,-0.6 -10.9,-0.6 -16.4,-0.1 7.1,-1 14.2,-1.9 21.3,-2.9 -6.2,0.9 -11.9,2.3 -17.7,4.5 6.3,-2.7 12.7,-5.4 19.1,-8.1 -6.6,2.8 -12.6,6.3 -18.4,10.6 5.4,-4.1 10.8,-8.3 16.2,-12.5 -6.6,5.3 -12.4,11.2 -17.7,17.9 4.1,-5.4 8.3,-10.8 12.5,-16.3 -6.7,8.9 -12.1,18.4 -16.5,28.5 2.7,-6.3 5.4,-12.7 8,-19.1 -4.7,11.5 -8,23.3 -9.9,35.6 0.9,-7.1 1.9,-14.2 2.8,-21.3 -1.8,14 -1.5,27.7 0.3,41.7 -0.9,-7.1 -1.9,-14.2 -2.8,-21.3 2.2,14.8 6.1,29.1 11.9,43 -2.7,-6.3 -5.4,-12.7 -8.1,-19.1 5,11.3 11.1,21.9 18.5,31.9 -4.2,-5.5 -8.4,-10.9 -12.6,-16.3 6.9,8.7 14.6,16.5 23.3,23.3 -5.5,-4.2 -10.9,-8.3 -16.3,-12.5 7.6,5.6 15.5,10.2 24.1,13.9 -6.4,-2.7 -12.7,-5.4 -19.1,-8.1 8.5,3.3 17,5.6 26,7 -7.1,-0.9 -14.2,-1.9 -21.3,-2.9 10.2,1.3 20.2,1.3 30.3,0.1 -7.1,0.9 -14.2,1.9 -21.3,2.9 8.8,-1.4 17.3,-3.7 25.6,-7.1 -6.4,2.7 -12.8,5.4 -19.2,8.1 7.1,-3.1 13.6,-6.9 19.8,-11.6 -5.4,4.2 -10.8,8.4 -16.3,12.5 5.2,-4.2 9.8,-8.8 14,-14 -4.2,5.4 -8.4,10.8 -12.5,16.2 4.4,-6.1 8.1,-12.4 11.1,-19.2 -2.7,6.3 -5.4,12.7 -8.1,19.1 3.1,-8 5.2,-15.9 6.4,-24.4 -1,7.1 -1.9,14.2 -2.9,21.3 1.1,-9.9 0.9,-19.6 -0.2,-29.5 0.9,7.1 1.9,14.2 2.8,21.3 -2.2,-15.5 -6.5,-30.3 -12.4,-44.8 2.7,6.3 5.4,12.7 8.1,19.1 -8.8,-20.6 -20.2,-39.8 -33.7,-57.7 4.2,5.4 8.4,10.8 12.6,16.3 -10.5,-13.5 -21.9,-25.8 -35.2,-36.4 5.4,4.2 10.8,8.4 16.2,12.6 -8.1,-6.1 -16.5,-11.2 -25.9,-15.2 6.4,2.7 12.8,5.4 19.2,8.1 -5.8,-2.1 -11.6,-3.7 -17.7,-4.8 7.1,0.9 14.2,1.9 21.3,2.8 -7,-0.8 -13.8,-0.9 -20.9,-0.1 7.1,-0.9 14.2,-1.9 21.4,-2.9 -6.7,1.1 -13,2.8 -19.2,5.4 6.4,-2.7 12.8,-5.4 19.2,-8 -5.1,2.3 -9.7,5.1 -14.2,8.3 5.4,-4.2 10.8,-8.3 16.2,-12.5 -6.8,5.2 -12.5,11.2 -17.8,18 4.2,-5.4 8.4,-10.8 12.5,-16.2 -7.2,9.8 -12.9,20.4 -17.7,31.6 2.7,-6.4 5.4,-12.8 8.1,-19.2 -9.1,22.2 -14.4,45.4 -17.8,69.1 1,-7.1 1.9,-14.3 2.9,-21.4 -2.7,20.4 -5.1,41.4 -2.5,61.8 -1,-7.1 -1.9,-14.2 -2.9,-21.3 1.1,5.9 2.5,11.3 4.7,16.9 -2.7,-6.4 -5.4,-12.8 -8.1,-19.2 2.3,5.1 5,9.6 8.4,14 -4.2,-5.4 -8.3,-10.8 -12.5,-16.2 3.5,4.1 7.3,7.7 11.6,11.1 -5.4,-4.2 -10.8,-8.4 -16.2,-12.5 5.4,3.8 11.1,6.9 17.2,9.6 -6.4,-2.7 -12.8,-5.4 -19.2,-8.1 8.6,3.4 17.2,5.5 26.3,6.7 -7.1,-0.9 -14.2,-1.9 -21.3,-2.8 9.1,0.9 18.1,0.8 27.2,-0.2 -7.1,0.9 -14.2,1.9 -21.3,2.8 10,-1.5 19.6,-4.1 29,-7.9 -6.4,2.7 -12.7,5.4 -19.1,8.1 11.3,-4.8 21.7,-11 31.5,-18.5 -5.4,4.2 -10.8,8.4 -16.2,12.5 9.6,-7.7 18.2,-16.4 25.8,-26.2 -4.2,5.4 -8.3,10.8 -12.5,16.2 8.1,-10.8 14.8,-22.4 20.1,-34.9 -2.7,6.4 -5.4,12.8 -8.1,19.2 4.6,-11.5 7.8,-23.2 9.6,-35.5 -0.9,7.1 -1.9,14.2 -2.8,21.3 1.3,-11.1 1.4,-22.1 0.1,-33.2 1,7.1 1.9,14.2 2.9,21.3 -0.8,-5.6 -1.9,-11 -3.3,-16.4 -10.6,-40.6 13.4,-89 56,-98.7 41.9,-9.5 87.3,12.6 98.6,56 24.4,93.4 -18.9,189.8 -97.4,242.8 -42,28.4 -92.2,36 -141.5,28.8 -55.8,-8.1 -101.4,-47.1 -120.3,-99.6 -15.5,-43 -6.4,-98 2.5,-141.7 6.9,-33.8 19.2,-69.4 39.7,-97.3 31.5,-42.7 74,-70.5 128.3,-72.1 53.6,-1.6 104.4,29.2 138.6,68.4 63.4,72.8 111.9,186 56.5,277.2 -30,49.6 -80.7,75.3 -137.1,80.7 -50.6,4.8 -98.6,-15.5 -136.7,-47.1 -34.9,-28.9 -59.5,-74.6 -69.1,-118.5 -9.5,-43.8 -9.7,-90.8 7.4,-132.8 17.6,-43.4 45.3,-85.1 89.6,-105 32.2,-14.4 62.8,-18.3 97.8,-12.2 28.8,5.1 53.4,21.1 75.6,39.3 35.2,28.9 60.9,74.8 72.4,118.5 12.5,48.1 10.7,103.4 -16.1,146.6 -27.1,43.6 -75.5,72.8 -127.8,67.9 -47.7,-4.4 -97.2,-26.6 -119.8,-71.6 -13.9,-27.6 -17.7,-57.7 -9.6,-87.9 10.9,-40.5 57.6,-69.3 98.7,-56 41.5,13.4 67.7,55.2 56,98.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17719,7090.2 c 34.7,-12.3 75.3,-33.1 111.7,-60.8 -2.9,2.2 -8.2,6.7 4.3,-3.7 4.5,-3.7 8.8,-7.6 13.1,-11.5 7.5,-6.7 14.6,-13.8 21.6,-21.1 18.5,-19.6 21.6,-23.5 35.5,-47.7 11.2,-19.5 11.5,-19.5 17.7,-41.1 0.8,-2.7 6.9,-32.5 5.2,-18.9 1.6,-12.4 1.6,-25.3 1,-37.7 -0.1,-1.7 -2,-19 -0.8,-10.5 1.2,7.4 -1.5,-6.2 -1.4,-6.1 -3,-10.9 -5.6,-21.8 -9.6,-32.4 3.7,9.8 -1.4,-2.9 -2,-4.1 -2.6,-5 -5.1,-10.1 -7.9,-15 -5.6,-9.8 -11.7,-19.6 -18.6,-28.5 5.9,7.7 -3.1,-3.2 -3.7,-3.8 -3.9,-4.2 -7.6,-8.5 -11.7,-12.6 -8,-8.2 -16.5,-16.1 -25.4,-23.4 6.7,5.5 -12.5,-8.7 -15.2,-10.4 -10.8,-7.1 -22,-13.6 -33.6,-19.2 -41.9,-20.3 -91.2,-29.4 -135.9,-31.7 -88.4,-4.5 -158.1,5.6 -241.6,36.3 -10.9,4 12.7,-5.9 2.4,-1.1 -2.7,1.3 -5.4,2.5 -8.1,3.7 -6.9,3.3 -13.7,6.7 -20.5,10.4 -12.8,7 -24.5,15.4 -36.8,23.2 -11.5,7.2 2.2,-1.8 3.8,-3.1 -2.6,2.2 -5.3,4.2 -7.8,6.4 -5,4.5 -10,8.8 -14.7,13.5 -4.1,4 -8,8 -11.8,12.2 -6.4,7.2 -14.1,19.3 -3.9,3.9 -6.3,9.5 -12.9,18.7 -18.5,28.8 -2.6,4.7 -4.7,11.8 -8.1,16 -5.6,7 5.1,-10.2 3.7,-9 -1.7,1.3 -4,10.2 -4.7,12.3 -3.6,10.3 -6.5,20.8 -8.7,31.5 -0.4,1.9 -3.4,14.6 -2.7,15 2.8,1.2 1.6,-20.7 1.3,-8.4 -0.1,3.5 -0.6,7.2 -0.8,10.8 -0.6,10.8 -0.5,21.7 0.2,32.5 0.2,2.9 0.6,5.9 0.7,8.7 0.3,14.2 -0.7,-8.9 -1.3,-8.2 -1.6,1.6 2.9,17 3.4,19.4 2.3,10.9 5.2,21.6 8.7,32.1 1.9,5.7 4.2,11.2 6.1,16.8 3.5,10.2 -8,-16 1,1.6 5.6,10.9 11.1,21.6 17.6,32 2.8,4.6 5.9,9 8.9,13.5 1.6,2.5 4.1,4.9 5.4,7.6 3.8,8.3 -11.7,-13.5 -2.6,-3.3 17.2,19.4 35.4,36.1 54.2,53.8 -12.2,-11.5 -5,-3.7 3.4,2.1 6.2,4.3 12.4,8.3 18.8,12.2 13.1,7.9 27.1,13.8 40.5,21.1 9.2,5 -15,-5.1 -4.9,-2.1 4.1,1.3 8.2,3.2 12.3,4.7 6.6,2.3 13.3,4.5 20.1,6.5 15.8,4.7 31.8,7.6 47.9,10.9 14,3 -2.5,-0.2 -4.7,-0.4 4.7,0.4 9.5,1 14.2,1.4 8.7,0.8 17.4,1.3 26.1,1.5 18.2,0.5 36.4,-0.2 54.5,-1.9 4.2,-0.4 8.3,-1 12.5,-1.4 -6.4,0.6 -11.9,2 -2.3,0.2 9.7,-1.8 19.4,-3.4 29.1,-5.6 21.5,-4.7 42.6,-10.9 63.4,-17.9 41,-13.9 87.7,16 98.7,56 12,43.9 -14.9,84.7 -56,98.6 -147.4,49.9 -319.8,45.5 -451.1,-45.3 -108.8,-75.2 -185.4,-197.1 -185.6,-331.9 -0.1,-143.3 92.4,-265.2 220.9,-322.1 200.6,-88.8 488.7,-88.6 646.9,82 96.9,104.5 123.2,247.2 62.3,376.9 -55.4,118 -174,198.1 -293.4,240.4 -40.9,14.5 -87.8,-16.4 -98.7,-56 -12.2,-44.3 15.1,-84.1 56,-98.6",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6342.53,6381.6 c -13.78,33 -31.95,64.4 -57.4,89.9 -14.12,14.1 -30.59,28.2 -50.41,33 -23.31,5.7 -47.69,-3.4 -63.69,-20.7 -12.04,-13 -20,-28.5 -28.04,-44.1 -9.16,-17.8 -18.11,-35.6 -25.61,-54.1 -13.65,-33.6 -25.42,-68 -36.7,-102.4 -5.01,-15.4 5.85,-34.5 21.59,-38 17.98,-4.1 31.43,5.5 38.03,21.5 9.14,22.3 21.93,48.4 34.7,72.3 2.94,-1.8 5.84,-3.8 9.26,-4.5 14.72,-3.4 27.41,1.3 36.6,10.6 l 0.76,-0.8 c 2.37,2.6 5.06,4.7 7.62,7 1.31,0.7 3.63,1.5 4.67,2.5 -4.54,-4.3 -6.13,-2.3 -1.17,-0.9 1.01,0.3 2.11,0.5 3.24,0.7 h 0.18 c 1.49,-0.1 3,-0.1 4.51,-0.2 2.3,-0.7 4.96,-1.2 7.26,-1.8 2.07,-0.6 4.1,-1.2 6.16,-1.8 l 0.6,-0.2 c 9.01,-4.7 17.55,-9.6 25.82,-15.6 13.52,-9.8 34.74,-6.1 46.88,3.3 12.01,9.2 21.54,29 15.14,44.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6501.22,6355.3 -0.08,0.1 c 5.8,-6 2.56,-1.8 0.08,-0.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6620.52,6348.7 c -6.35,26 -15.82,51 -27.28,75.1 -5.28,11.2 -11.17,22 -17.67,32.4 -8.49,13.7 -17.94,27.5 -32.24,35.8 -22.45,12.9 -48.95,8.9 -67.77,-8.4 -10.52,-9.6 -18.14,-22.7 -25.95,-34.5 -13.94,-21 -26.94,-42.7 -39.08,-64.8 -8.61,-15.7 -4.35,-38.1 12.3,-46.8 7.94,-4.2 17.57,-6.4 26.39,-3.5 9.06,2.9 14.73,8.3 20.47,15.7 -5.35,-6.9 0.05,0.1 0.89,1.1 1.3,1.7 2.6,3.4 3.94,5 2.81,3.6 5.64,7.1 8.51,10.6 1.82,-1 3.6,-2 5.37,-3 4.39,-2.4 8.65,-5.1 12.74,-8 l -0.68,0.7 c 1.7,-1.8 4,-3.3 5.88,-4.9 15.63,-13.5 27.9,-29.7 42.31,-44.3 12.9,-13 36.26,-16.9 52.11,-6.7 16.39,10.6 24.43,29.4 19.76,48.5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6454.73,6104.2 c -5.69,2.5 -12.58,2.8 -17.21,-2.2 -5.5,-6 -7.9,-11.5 -7.22,-19.7 0.44,-5.4 0.8,-10.7 0.52,-16.1 -0.05,-0.9 -0.16,-1.9 -0.24,-2.8 -0.05,-0.1 -0.16,-0.7 -0.34,-1.7 l -1.38,-5.1 c -0.96,-1.8 -3.13,-5.3 -1.2,-2.9 -0.78,-0.9 -1.6,-1.7 -2.48,-2.5 1.62,1 1.49,1 -0.44,-0.3 -0.39,-0.2 -4.21,-1.7 -2.35,-1.4 -1.49,-0.1 -2.95,-0.2 -4.44,-0.1 1.51,-0.4 1.01,-0.3 -1.44,0.2 -4.54,1 -8.22,2.9 -11.35,5.5 -8.91,7.6 -14.12,18.4 -20,29.1 -4.25,7.7 -14.25,11.5 -22.63,9.2 -7.73,-2.2 -15.82,-10.8 -14.7,-19.4 0.29,-2.3 0.5,-4.5 0.45,-6.9 l -0.11,-2.3 -0.26,-1.3 c -0.44,-1.6 -0.89,-3.2 -1.44,-4.8 l -1.61,-3.4 c -0.68,-1.1 -1.39,-2.3 -2.15,-3.4 1.15,1.4 0.95,1.2 -0.57,-0.5 -1.38,-1.4 -2.69,-2.9 -4.25,-4.1 2.76,2.1 -2.35,-1.1 -2.46,-1.1 2.92,1.5 -2.43,-0.8 -3.42,-1 l -2.5,0.1 c -0.24,0.1 -1.49,0.4 -2.48,0.7 l -3.29,1.7 c -1.93,1.3 -2.2,1.5 -0.73,0.5 l -2.15,2.1 -1.98,2.2 c 1.15,-1.4 1.07,-1.1 -0.26,0.8 l -0.47,0.9 c 0.11,-0.2 0.11,-0.1 -0.57,1.4 l -0.5,1 0.08,1.3 0.03,0.8 c 0.26,1.1 0.6,2.2 1.01,3.3 3.58,10 -4.02,21.5 -13.7,24.2 -10.91,3 -20.52,-3.7 -24.15,-13.7 -11.82,-32.6 19.53,-69.2 53.02,-66.9 17.31,1.2 32.19,11.1 42.19,24.6 3.07,-3 5.61,-6.5 9.21,-9.1 16.47,-11.5 38.87,-14.7 57.01,-5.4 14.65,7.5 23.63,22.7 26.26,38.5 2.66,15.9 4.23,42.5 -13.31,50",
    style: {
      fill: "#691b1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6240.46,6082.6 c -0.57,8 -2.03,14.3 -6.08,21.3 -2.32,4 -5.3,8 -8.87,11 -6.79,5.7 -10.57,7.9 -18.9,11 -4.33,1.7 -9.22,2.1 -13.78,2.4 -9.27,0.5 -18.15,-2.6 -26.35,-6.6 -3.86,-1.9 -7.28,-4.9 -10.57,-7.6 -3.62,-2.9 -6.36,-6.9 -9.08,-10.6 -5.46,-7.5 -7.44,-16.6 -8.17,-25.7 -0.68,-8.3 2.17,-18.2 6.5,-25.3 4.39,-7.1 10.34,-13 17.57,-17.2 8.04,-4.8 15.29,-6.2 24.35,-7.2 1.57,-0.1 3.11,-0.1 4.65,0 3.94,0.4 8.72,0.7 12.68,2.2 3.58,1.3 8.05,2.8 11.36,5.3 6.94,5 9.35,7.2 14.31,14.3 1.98,2.9 3.47,6.7 4.67,10.5 l 0.63,0.8 c 3.16,7 5.66,13.6 5.08,21.4",
    style: {
      fill: "#691b1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6584,6083.9 c -0.21,1.4 -0.4,3.1 -0.66,4.6 l -0.07,0.4 -2.93,7 -0.76,1.5 -0.91,1.4 c -1.67,2.3 -3.39,4.7 -5.33,6.7 l -1.61,1.3 -0.66,0.9 -0.99,1 -0.49,0.5 c -2.07,1.7 -4.49,3.6 -6.68,5.1 l -1.21,0.8 -0.67,0.3 c -2.54,1.1 -5.18,2.3 -7.78,3.3 l -1.49,0.4 c -2.64,0.5 -5.98,0.9 -8.64,1.1 l -0.73,0.1 h -0.76 -0.5 c -2.63,-0.3 -5.87,-0.7 -8.45,-1.2 l -1.46,-0.3 -0.84,-0.3 c -2.61,-1 -5.38,-2.1 -7.94,-3.3 l -1.38,-0.9 c -1.26,-0.8 -2.53,-1.9 -3.63,-2.7 -1.15,-0.9 -2.53,-1.9 -3.7,-2.9 l -1.15,-1.2 c -1,-1.1 -1.96,-2.5 -2.82,-3.6 -0.92,-1.2 -1.99,-2.5 -2.88,-3.7 l -0.85,-1.5 -0.35,-0.7 c -1.2,-2.6 -2.4,-5.3 -3.39,-8 l -0.47,-1.5 -0.15,-0.7 c -0.53,-2.9 -0.92,-6 -1.21,-9 l -0.07,-1.5 0.05,-0.9 c 0.23,-2.8 0.68,-5.9 1.17,-8.7 l 0.42,-1.6 c 0.91,-2.6 2.14,-5.3 3.26,-7.8 l 0.39,-0.8 0.87,-1.4 c 1.59,-2.2 3.34,-4.5 5.09,-6.6 l 0.57,-0.6 1.17,-1.1 c 2.15,-1.7 4.36,-3.5 6.61,-5 l 0.81,-0.6 1.33,-0.6 c 2.5,-1.2 5.17,-2.3 7.75,-3.3 l 0.95,-0.3 1.43,-0.4 c 1.56,-0.3 3.26,-0.4 4.8,-0.6 1.51,-0.2 3.21,-0.5 4.81,-0.7 h 1.48 c 3.21,0 6.45,0.7 9.61,1.2 l 1.59,0.3 0.68,0.3 c 2.61,1 5.3,2.1 7.83,3.3 l 1.41,0.7 0.6,0.5 c 2.22,1.5 4.52,3.3 6.58,5 l 1.17,1.1 0.5,0.6 c 1.75,2.1 3.57,4.4 5.14,6.7 2.01,3 3.21,6.5 4.39,9.9 l 0.42,1.5 0.15,0.9 c 0.45,2.7 0.89,5.7 1.13,8.4 0.23,2.4 -0.24,4.8 -0.55,7.2",
    style: {
      fill: "#691b1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path210"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g214",
    clipPath: "url(#clipPath218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13070.8,4793.6 h 30.699 v 167.898 h -30.699 z",
    style: {
      fill: "#e8d29e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path220"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 12695.3,5786.8 c -6,120.2 35,253.3 157.4,282.3 0.3,15.4 0.6,30.7 0.7,45.9 0.6,73.3 8.2,144.9 29.3,215.3 43,143.4 129.5,270.1 217.6,389.2 91.8,124.1 185.3,256.6 314,345.3 58.2,40.2 154.2,92.4 235.1,136.7 0.5,-0.9 1,-1.8 1.5,-2.7 0.4,-11.7 3.7,-23.9 10.5,-36.3 103.9,-189.2 187.4,-392.4 264.7,-595.5 -38.4,-59.1 -63.7,-130.2 -87.4,-192 -9.3,-24 -29.4,-30.3 -53.6,-30.3 -26.3,0 -57.6,7.5 -85,7.7 -66.6,0.4 -129.5,21.6 -192.6,40.5 -41.3,12.3 -83.2,23.5 -125.7,23.5 -16.1,0 -32.3,-1.6 -48.6,-5.3 -83.6,-19.4 -150.2,-93.4 -206.3,-153.5 -56.8,-60.7 -110.6,-128.2 -176.6,-179.9 18.5,81.6 34.4,164 67.7,240.9 42.2,97.5 85.6,181.6 150.8,266.2 117.8,152.7 241.1,288 423.1,364.4 58.7,24.6 36.3,108 -17.9,108 -6.3,0 -13,-1.1 -20.1,-3.6 -194,-67.9 -381.5,-209 -479.2,-393.4 -49.3,-93.2 -88,-207.4 -109.9,-310.6 -20.3,-95.3 -40,-193.4 -41.1,-291.3 -15.4,-10.3 -31.8,-19.6 -49.1,-26.4 -0.3,0.4 -0.7,0.9 -1.2,1.7 -4.6,7 -3.3,6.3 -10.9,11.5 0.5,-0.3 0.7,-0.5 0.6,-0.5 -0.4,0 -5.9,3 -8.1,3.9 -0.1,0 -0.2,0 -0.4,0.1 0.2,0 0.3,-0.1 0.4,-0.1 0.2,-0.1 0.2,-0.1 0.1,-0.1 -0.8,0 -8.3,1.8 -10.3,2 -2.1,0.3 -4.4,0.4 -6.9,0.4 -5.3,0 -11.3,-0.5 -17.4,-1.4 -9.4,-1.3 -18.6,-3.7 -27.7,-6.5 -75.9,-51.7 -102.3,-157.9 -97.5,-255.6 0,-0.2 0,-0.3 0,-0.5 M 13793,7343.7 c -7.2,192.4 -39.5,776.8 -37.6,862.1 1.3,56.2 3.1,122.2 61.1,148.1 2,0.9 3.9,1.2 5.6,1.2 0.9,0 1.6,-0.1 2.4,-0.2 44.5,49.6 121.9,59.5 193.3,59.5 7.8,0 15.4,-0.1 23,-0.3 93,-2.4 262.4,-2.8 288.9,-117 3.4,-14.6 8,-177.5 12.6,-249.4 7.6,-117.5 11.9,-235.3 17.3,-352.9 2.2,-49.8 4.4,-99.6 6.6,-149.4 -131.5,-54.8 -265.2,-104 -400.2,-148.1 -57.4,-18.7 -115.1,-36.5 -173,-53.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14783.3,6932.5 c -14.1,10.4 -28.6,20.6 -43.9,30.6 -9.2,6 -18.2,8.6 -26.6,8.6 -9.3,0 -17.9,-3.3 -24.7,-8.5 -97,37.1 -192.7,64 -277.1,85.3 -171.8,43.5 -355.4,74.7 -559.9,94.9 -7.1,14.7 -14.3,29.4 -21.6,43.9 183.7,54.2 365.6,116.5 543.7,188.4 0.8,-19.9 1.6,-39.8 2.4,-59.6 0.5,-13.9 1.5,-28.3 2.6,-42.9 234.8,-60.6 451.5,-177.8 636.3,-335 -41,25.8 -85.6,46.9 -133.5,62.3 -9,2.9 -17.6,4.2 -25.6,4.2 -41,0 -67.9,-34.7 -72.1,-72.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(185, 231, 206)"
    },
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14598.2,6399.2 c -36.4,0 -69.8,27.4 -93.4,54.1 -2.5,2.8 -4.7,5.8 -7,8.7 -24.3,9 -45.7,25.4 -65.4,42 -9.8,8.4 -10.2,22.7 -2.5,32.6 4,5.1 10.2,7.7 16.5,7.9 -1.5,3.1 -3.1,6.2 -4.6,9.4 -38.1,43.2 -68.2,93.1 -123.8,129.4 -23.5,15.2 -114.7,19.3 -142,25.6 -6,1.4 -12.6,2.1 -19.4,2.1 -31.3,0 -70,-13.5 -104.6,-31.3 -40.6,100.7 -82.8,200.7 -126.5,300 -15.8,35.7 -31.6,71.6 -47.9,107.2 189.1,-20 360.1,-49.6 520.3,-90.1 85.1,-21.6 181.9,-48.8 279.3,-86.8 3.7,-6 9.2,-11.6 16.9,-16.4 54.7,-34.1 110.9,-69.8 163.8,-106.6 53.8,-37.5 99,-85.5 152.7,-123.4 3,-2.1 6.2,-3.1 9.2,-3.1 10.3,0 18.7,11.1 12,22.3 -9.3,15.5 -19.5,29.8 -30.3,43.4 87.1,-77.1 138.2,-176.1 164.5,-287.9 -24.1,3.3 -50.2,5.4 -79.5,5.4 -22.6,0 -47,-1.2 -74.1,-4.2 -0.7,-0.1 -1.5,-0.1 -2.2,-0.1 -35.1,0 -69.8,88.2 -128.2,91 -1.2,0 -2.4,0 -3.7,0 -42.5,0 -105.9,-32.2 -161,-51.9 -7.2,-16.1 -16.6,-30.9 -29.2,-42.9 -15,-14.3 -31.5,-21.5 -48.4,-23.6 -3.9,-2.5 -8,-4.8 -12.3,-6.6 -9.9,-4.3 -19.6,-6.2 -29.2,-6.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(185, 231, 206)"
    },
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13829.5,7187.3 c -9.6,18.9 -19.4,37.6 -29.6,56.1 -7.2,13.1 -16.2,22.6 -26.3,29 13.2,8.7 20.8,15 20.8,18.2 0.1,9.8 -0.5,28.2 -1.4,53.1 57.9,17.1 115.6,34.9 173,53.6 135,44.1 268.7,93.3 400.2,148.1 2.4,-56.6 4.8,-113.2 7,-169.7 -178.1,-71.9 -360,-134.2 -543.7,-188.4 m -178.6,11.5 c -0.5,0.9 -1,1.8 -1.5,2.7 0.5,0.2 0.9,0.5 1.4,0.7 0,-1.1 0,-2.3 0.1,-3.4",
    style: {
      fill: "#ae6561",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15387.6,6348.1 v 0 c -1.5,17.8 -4.1,35.4 -7.4,52.9 -14.7,0.6 -28.7,1.9 -42.2,3.7 -4.2,29.7 -10,59.2 -17.3,88.8 -19.8,79 -51,155.2 -93,224.2 84.5,-110.1 148.6,-235.8 159.9,-369.6 v 0",
    style: {
      fill: "#99d536",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13803.7,6704.5 c 3.9,-98.1 -11.6,-196.1 -1.4,-294.2 1.1,-10.3 2.6,-22.5 4.8,-31.4 1,-4.1 2.3,-8.2 3.6,-12.2 1.6,-4.6 2.2,-5.3 2.6,-6 l 1.7,-2.1 2.5,-1.9 c 3.4,-2.1 7.3,-4.3 11.2,-5.5 5,-1.6 12.4,-1.4 16,-0.4 17.8,4.5 32.6,19.7 44.8,33.7 18.1,20.8 33.2,44.1 47.6,67.7 28.1,46 52.5,95.7 86.6,137.7 36.4,44.9 98,67.8 155,63.6 111.8,-8.2 183.5,-107.9 269.9,-169.6 2.4,57.3 -3.8,115 -11.2,171.8 -8.3,63.4 -18.8,126.5 -25.3,190.1 -6.8,66.6 -6.6,133.8 -7.2,200.8 -0.7,73.3 -1,146.7 -2.7,220 -8,2.2 -16,4.5 -24,6.6 -1.1,14.6 -2.1,29 -2.6,42.9 -4.9,126.2 -10.3,252.4 -16,378.7 -5.4,117.6 -9.7,235.4 -17.3,352.9 -4.6,71.9 -4,146.5 -21.1,216.2 7.7,7.5 11.9,18.6 8.5,33.2 -26.5,114.2 -195.9,114.6 -288.9,117 -77.1,2 -167,-4.2 -216.3,-59.2 -2.4,0.4 -5.1,0.3 -8,-1 -58,-25.9 -59.8,-91.9 -61.1,-148.1 -2.2,-96.3 34.5,-534.7 36.9,-658.6 1.7,-85.5 2.4,-171.1 2.1,-256.6 0,-18.8 -0.5,-38 -1.1,-57.2 -4.5,-2.7 -9.1,-5.1 -13.6,-7.6 16,-173.2 17.2,-347.5 24,-521.3",
    style: {
      fill: "#644d44",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14132.7,8202.3 c 37,5.7 81.6,17.7 108.8,40.9 16,13.6 25.1,34.7 15.6,51.5 -5.9,10.4 -17.8,17.5 -29.6,23.6 -96.1,48.6 -211.7,51.4 -317,14.5 -63.8,-22.4 -135.4,-85.5 -49.5,-124.9 67.1,-30.8 196.3,-17.1 271.7,-5.6",
    style: {
      fill: "#55403a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14151.3,8157.9 c 12.8,-23.5 19.8,-68.9 21,-95.5 20.9,-472 55.2,-1002.7 56.9,-1323.9 0.3,-40.2 45.9,-76.1 45.4,-116.3 62.8,-36.3 115,-96.2 174,-138.3 2.4,57.3 -3.8,115 -11.2,171.8 -8.3,63.4 -18.8,126.5 -25.3,190.1 -6.8,66.6 -6.6,133.8 -7.2,200.8 -0.7,73.3 -1,146.7 -2.7,220 -8,2.2 -16,4.5 -24,6.6 -1.1,14.6 -2.1,29 -2.6,42.9 -4.9,126.2 -10.3,252.4 -16,378.7 -5.4,117.6 -9.7,235.4 -17.3,352.9 -4.4,69 -4.2,140.4 -19.2,207.7 -30.9,-52.7 -82.1,-87.9 -171.8,-97.5",
    style: {
      fill: "#55403a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15387.6,6348.1 c -1.5,17.8 -4.1,35.4 -7.4,52.9 -123.2,5.4 -192.5,57.8 -367.8,38.5 -35.8,-3.9 -70.7,88 -130.4,90.9 -42.4,2 -107.9,-31.7 -164.7,-51.9 -7.2,-16.1 -16.6,-30.9 -29.2,-42.9 -15,-14.3 -31.5,-21.5 -48.4,-23.6 -3.9,-2.5 -8,-4.8 -12.3,-6.6 -47.3,-20.7 -92.8,14.1 -122.6,47.9 -2.5,2.8 -4.7,5.8 -7,8.7 -24.3,9 -45.7,25.4 -65.4,42 -9.8,8.4 -10.2,22.7 -2.5,32.6 4,5.1 10.2,7.7 16.5,7.9 -1.5,3.1 -3.1,6.2 -4.6,9.4 -38.1,43.2 -68.2,93.1 -123.8,129.4 -23.5,15.2 -114.7,19.3 -142,25.6 -55.1,12.9 -150.1,-37 -192.9,-74.4 -73.5,-64.2 -110.6,-171.4 -144.4,-259.5 -19.3,-50.2 -86,-23 -138.6,-22.6 -66.6,0.4 -129.5,21.6 -192.6,40.5 -56.9,17 -115,31.9 -174.3,18.2 -83.6,-19.4 -150.2,-93.4 -206.3,-153.5 -62.6,-67 -121.6,-142.2 -197.3,-195.2 -29.5,-20.8 -63.3,-38 -99.8,-41.5 -19.5,-1.8 -38.3,0.9 -56,7 -81.8,-74 -92.8,-220.1 -66.2,-325.7 26.5,-105.1 113.6,-198.5 218.3,-235.7 3.9,-32.2 -4.4,-69 -3.5,-98.4 1,-34.1 7.2,-67 18.6,-99 22.4,-63.2 68.2,-99 103.7,-148.7 20.9,-121.3 37.3,-243.1 64.8,-363.5 31.5,-137.5 67,-274.4 103.8,-410.7 28.1,-103.6 40.5,-247.7 113.2,-331.6 35.6,-41.1 102.2,-93.3 162.8,-95.7 37.3,-47 53.3,-116.9 83.7,-164.4 43.5,-67.8 105.8,-91.7 182.2,-106.5 187.7,-36.2 380.6,-46.9 571.3,-37.1 182.5,9.4 366.2,37.1 541.5,89.2 64.3,19.1 129.2,43.3 165.3,103.7 18.8,31.5 25.6,66.8 26,102.6 70.4,41.1 129.6,108.7 176.3,170.1 79.9,105.1 90.3,243 109.4,369.3 46.9,309.9 68.7,616.7 73.7,929.1 86.8,98.9 85.6,267.1 67.7,393.5 58.8,79.1 96.8,183.2 105.4,270.2 14.1,142.8 -91.4,242.4 -204.2,309.5",
    style: {
      fill: "#feefe6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15502.6,6125.2 c -173.9,74.2 -625.7,-184.1 -740.3,-261.4 -109.8,-74 -221,-162.7 -353.3,-170 -86.8,-4.7 -172.1,26.6 -256.4,57.9 -107.7,40 -213.7,80 -319.1,44.8 -146,-48.9 -237.2,-231.3 -391.2,-229.1 -79.4,1.2 -147.8,53.7 -208.3,105.1 -138.2,117.4 -353.5,180.5 -292.7,381 -167.6,-107.9 -289.3,-390.4 -139.1,-521.3 31.3,-27.2 68.1,-48.8 93.1,-81.9 21.5,-28.4 32.5,-63.1 43,-97.1 25.8,-83.1 91.1,-208 112.2,-298.5 101.6,-435.9 138.6,-1092.4 449.3,-1190.8 76.5,-24.2 -20.8,-124.8 154.7,-195.8 63.9,-25.9 127.7,-50.6 196.1,-59.5 283.4,-36.7 572.7,-27.3 853.1,27.7 81,15.9 162.7,36.2 232.7,79.9 46,28.8 85,66.5 120.8,107.6 -1.6,3.9 -2.2,8.3 -1.4,12.7 3.6,21.8 16.7,64.9 30.6,82.3 11.1,14.1 20.9,2.8 36,12.3 12.6,8 25.6,15.2 38.2,23 48,63.3 93.9,128.4 126,200.8 62.7,141.7 68.5,301 78.1,455.6 27.3,439.1 92.5,875.8 194.8,1303.7 29.3,122.2 2.2,185.8 -56.9,211",
    style: {
      fill: "#fcce7b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15363.7,5580.9 c -43.3,-7.6 -87.4,-7.9 -131,-13.1 -44.5,-5.3 -86.4,-17.6 -125.3,-40.1 -62.4,-36 -104.4,-94.3 -149.7,-148.6 -45.5,-54.5 -97.9,-103.4 -167.1,-125 -77.4,-24 -164.7,-11.6 -241.3,9.1 -77.9,21.1 -152.4,52.8 -230.5,73.2 -75.6,19.7 -153.8,24.1 -229.9,3.3 -77.2,-21.2 -144.3,-65.4 -213.4,-104.2 -69.6,-39 -143.6,-73 -224.7,-76.1 -67.5,-2.5 -137.1,7.5 -190,52.4 -20.1,17 -37.6,36.7 -57.7,53.7 -24,20.3 -50.9,35.5 -78.7,50 -60.8,31.8 -123.8,59.2 -184.4,91.4 -63,33.5 -125.5,71.4 -177,121.2 -44.9,43.2 -86.7,99.4 -97.9,162.1 -7.8,43.4 -1.1,89.6 4.5,132.9 5.9,45.5 14.2,91.5 15.4,137.2 0.2,10.4 0.1,20.8 -0.7,31.1 -0.7,9.2 -2,18.2 -3.5,23.6 -1.2,4.3 -2.6,8.6 -4.3,12.7 -2.4,5.8 0.3,1 -3.1,5.9 -4.6,7 -3.3,6.3 -10.9,11.5 3.1,-2.1 -5.6,2.7 -7.9,3.5 2.9,-1 -7.4,1.5 -9.8,1.8 -6.6,0.9 -15.3,0.3 -24.3,-1 -9.4,-1.3 -18.6,-3.7 -27.7,-6.5 -99,-67.5 -113.7,-227.4 -85.2,-340.7 26.5,-105.1 113.6,-198.5 218.3,-235.7 3.9,-32.2 -4.4,-69 -3.5,-98.4 1,-34.1 7.2,-67 18.6,-99 22.4,-63.2 68.2,-99 103.7,-148.7 20.9,-121.3 37.3,-243.1 64.8,-363.5 31.5,-137.5 67,-274.4 103.8,-410.7 28.1,-103.6 40.5,-247.7 113.2,-331.6 35.6,-41.1 102.2,-93.3 162.8,-95.7 37.3,-47 53.3,-116.9 83.7,-164.4 43.5,-67.8 105.8,-91.7 182.2,-106.5 187.7,-36.2 380.6,-46.9 571.3,-37.1 182.5,9.4 366.2,37.1 541.5,89.2 64.3,19.1 129.2,43.3 165.3,103.7 18.8,31.5 25.6,66.8 26,102.6 70.4,41.1 129.6,108.7 176.3,170.1 79.9,105.1 90.3,243 109.4,369.3 46.9,309.9 68.7,616.7 73.7,929.1 58.8,67 77.1,165.7 77.4,261.8 -38.3,-28.2 -83,-47 -132.4,-55.8",
    style: {
      fill: "#f8a347",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15404.5,5491.3 c -26.5,-1.5 -52.9,0.4 -79.4,0.8 -3.9,0.1 -8.5,-0.3 -13,-0.6 -6.4,-0.5 -12.7,-1 -17,-0.4 1.2,-0.2 0.4,-0.3 -0.5,-0.4 -3.7,-7.1 -11.7,-14.2 -16.2,-20.8 -11.8,-17.5 -21.2,-37.3 -21.4,-58.7 -0.2,-19.3 5.2,-38.4 8.9,-57.2 11.5,-57.5 4.5,-113.5 -16.3,-168.2 -22.7,-60.1 -61.3,-112.5 -101.5,-161.9 -20.4,-25.2 -41.4,-50 -61.2,-75.7 -20.1,-26.1 -36.8,-54.1 -55.6,-81.1 -31.6,-45 -85.5,-86.5 -91.9,-144.3 -3.2,-30 1.4,-60.6 0.1,-90.8 -1.5,-34.4 -9.5,-67 -28.3,-96.1 -35.3,-54.8 -87.9,-93.9 -150.6,-111.6 -56.5,-15.9 -115.5,-17.3 -172.5,-30.1 25.5,24.4 4.2,83.3 -43.2,79.5 -54.7,-4.4 -41.9,-82.6 7.2,-89.4 -20.5,-6.6 -40.6,-15 -58.2,-26.8 -26.3,-17.6 -48.1,-41.3 -67.8,-65.8 -39.4,-49.1 -70.9,-104.6 -115.2,-149.7 -48.7,-49.6 -112.8,-85.3 -176.3,-112.6 -61.4,-26.3 -127.2,-43.1 -193.7,-49.7 -262.5,-26.1 -516.3,102.8 -706.7,275.5 18.3,-86.2 39.3,-179.4 92.3,-240.6 35.6,-41.1 102.2,-93.3 162.8,-95.7 37.3,-47 53.3,-116.9 83.7,-164.4 43.5,-67.8 133.5,-111.2 210,-125.9 187.7,-36.2 354,-44.2 544.7,-34.4 182.5,9.3 365,53.8 540.3,105.9 64.3,19.1 129.2,43.3 165.3,103.7 18.8,31.5 25.6,66.8 26,102.6 70.4,41.1 129.6,108.7 176.3,170.1 79.9,105.1 90.3,243 109.4,369.3 46.9,309.9 68.7,616.7 73.7,929.1 34,38.8 54.5,88.2 65.7,141.6 -25.1,-13.7 -51.7,-23.6 -79.9,-25.2",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14290.5,4648.7 c -58.7,-4.6 -39.8,-94.3 18.4,-89.7 58.7,4.7 39.7,94.4 -18.4,89.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13803.1,4730 c -58.7,-4.6 -39.8,-94.3 18.4,-89.7 58.6,4.7 39.7,94.4 -18.4,89.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13808.4,4355.3 c -1.4,-0.1 -0.9,-2.2 0.5,-2.1 1.4,0.1 0.9,2.2 -0.5,2.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14625,4976 c -58.7,-4.6 -39.7,-94.3 18.4,-89.7 58.7,4.7 39.7,94.4 -18.4,89.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14255.9,5081.8 c -58.7,-4.7 -39.7,-94.4 18.4,-89.7 58.7,4.7 39.7,94.4 -18.4,89.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13922.6,4441.1 -1.8,-0.5 c 1.3,26.3 -19.2,56.9 -53.8,54.1 -58.7,-4.7 -39.8,-94.4 18.3,-89.7 19.7,1.5 30.5,12.7 34.2,26.7 0.9,-0.9 2.1,-1.4 3.7,-1.3 6.9,0.6 6.3,11.3 -0.6,10.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15018.7,5127.7 c -58.7,-4.7 -39.8,-94.4 18.4,-89.7 58.7,4.7 39.7,94.4 -18.4,89.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14263,4240.8 c -58.7,-4.7 -39.8,-94.4 18.3,-89.7 58.7,4.6 39.8,94.3 -18.3,89.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13665.1,4388.4 c -58.7,-4.7 -39.8,-94.4 18.3,-89.7 58.7,4.7 39.8,94.3 -18.3,89.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12923.7,6058.3 c 1.1,97.9 20.8,196 41.1,291.3 21.9,103.2 60.6,217.4 109.9,310.6 97.7,184.4 285.2,325.5 479.2,393.4 7.1,2.5 13.8,3.6 20.1,3.6 54.2,0 76.6,-83.4 17.9,-108 -182,-76.4 -305.3,-211.7 -423.1,-364.4 -65.2,-84.6 -108.6,-168.7 -150.8,-266.2 -33.3,-76.9 -49.2,-159.3 -67.7,-240.9 -6.7,-5.3 -13.6,-10.4 -20.7,-15.3 -1.9,-1.4 -3.9,-2.8 -5.9,-4.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12932,6009.3 c 1.5,14 4.6,28.7 9.3,44.2 -5.9,-3.8 -11.8,-7.9 -17.6,-12.1 -0.1,5.6 -0.1,11.2 0,16.9 2,1.3 4,2.7 5.9,4.1 7.1,4.9 14,10 20.7,15.3 -4.9,-21.8 -10,-43.5 -15.7,-65.1 -0.4,-1.6 -1.4,-2.7 -2.6,-3.3",
    style: {
      fill: "#fffaf8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12929.3,6008.6 c -2.3,0 -4.6,1.5 -4.7,4.5 -0.5,9.4 -0.8,18.8 -0.9,28.3 5.8,4.2 11.7,8.3 17.6,12.1 -4.7,-15.5 -7.8,-30.2 -9.3,-44.2 -0.8,-0.5 -1.8,-0.7 -2.7,-0.7",
    style: {
      fill: "#feefd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13028.5,5125.8 c -2.6,1.5 -5.2,3.2 -8,5.1 -37.4,24.9 -65.9,57.2 -85.3,97.7 -8.9,18.5 -15.8,37.8 -20.2,57.6 6.8,-0.1 13.6,-0.1 20.5,-0.1 1.1,-3.7 2.2,-7.4 3.4,-11 v 0 c 0.1,-0.4 0.2,-0.7 0.4,-1.1 0.5,-1.6 1.1,-3.3 1.7,-4.9 v 0 c 16.9,-47.9 47.3,-80 76.4,-114.3 3.9,-9.8 7.6,-19.5 11.1,-29",
    style: {
      fill: "#f5ebd3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12935.5,5286.1 c -6.9,0 -13.7,0 -20.5,0.1 -6.8,30.1 -8,61.3 -2.3,92.3 1.7,9.6 4.6,18.2 7.6,26.7 1.1,-2.6 2.2,-5.3 3.3,-8 -0.9,-10.2 -1.5,-20 -1.2,-29.1 v 0 0 c 0.8,-28.1 5.2,-55.4 13.1,-82",
    style: {
      fill: "#d9b5b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13017.4,5154.8 c -29.1,34.3 -59.5,66.4 -76.4,114.3 16.9,-47.9 47.3,-80 76.4,-114.3 v 0 m -78.1,119.2 c -0.2,0.4 -0.3,0.7 -0.4,1.1 0.1,-0.4 0.2,-0.7 0.4,-1.1 m -0.4,1.1 c -1.2,3.6 -2.3,7.3 -3.4,11 v 0 c 1.1,-3.7 2.2,-7.4 3.4,-11",
    style: {
      fill: "#f8f0de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12935.5,5286.1 v 0 c -7.9,26.6 -12.3,53.9 -13.1,82 0.8,-28.1 5.2,-55.4 13.1,-82",
    style: {
      fill: "#e2c6c4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12922.4,5368.1 c -0.3,9.1 0.3,18.9 1.2,29.1 v 0 c -0.8,-8.6 -1.3,-17 -1.3,-25 0,-1.4 0,-2.8 0.1,-4.1",
    style: {
      fill: "#e2c6c4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12755.4,5593.3 c -38.7,55.7 -59.2,124.6 -60.1,193.5 1.4,-29.5 5.7,-58.3 12.3,-84.6 8.3,-32.7 22.4,-64.4 41.2,-93.5 2,-5.2 4.2,-10.3 6.6,-15.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12748.8,5608.7 c -18.8,29.1 -32.9,60.8 -41.2,93.5 -6.6,26.3 -10.9,55.1 -12.3,84.6 0,0.2 0,0.3 0,0.5 0,-0.3 0,-0.5 0,-0.7 v -0.1 c 0,-0.2 0,-0.3 0,-0.5 0,-0.1 0,-0.2 0,-0.2 0,-0.2 0,-0.3 0.1,-0.5 0,-0.1 0,-0.2 0,-0.3 0,-0.1 0,-0.2 0,-0.4 0,-0.1 0,-0.3 0,-0.4 0,-0.1 0,-0.2 0,-0.2 0,-0.2 0.1,-0.5 0.1,-0.7 v 0 c 1.6,-28.3 5.8,-55.9 12.1,-81.1 v 0 c 8.3,-32.7 22.4,-64.4 41.2,-93.5 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12707.6,5702.2 c -6.3,25.2 -10.5,52.8 -12.1,81.1 1.6,-28.3 5.8,-55.9 12.1,-81.1 m -12.1,81.1 c 0,0.2 -0.1,0.5 -0.1,0.7 0,-0.2 0.1,-0.5 0.1,-0.7 m -0.1,0.9 c 0,0.1 0,0.3 0,0.4 0,-0.1 0,-0.3 0,-0.4 m 0,0.8 c 0,0.1 0,0.2 0,0.3 0,-0.1 0,-0.2 0,-0.3 m -0.1,0.8 c 0,0 0,0.1 0,0.2 0,-0.1 0,-0.2 0,-0.2 m 0,0.7 v 0.1 -0.1",
    style: {
      fill: "#fffaf8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13045.4,5116.2 c -5.1,2.7 -10.7,5.8 -16.9,9.6 -3.5,9.5 -7.2,19.2 -11.1,29 v 0 c 9.4,-11 18.7,-22.3 27.3,-34.4 0.2,-1.4 0.5,-2.8 0.7,-4.2 m -121.8,281 v 0 0 c -1.1,2.7 -2.2,5.4 -3.3,8 1.9,5.3 3.7,10.4 5.4,15.8 -0.7,-8 -1.5,-16 -2.1,-23.8 m 96.6,83 c -20.1,14.7 -39.3,30.6 -57.2,47.9 -18.8,18 -37,38.4 -52.7,60.5 45.8,-29.1 96.3,-55.6 109.2,-105.6 0.3,-0.9 0.5,-1.9 0.7,-2.8 m -188,37.8 c -30.6,20 -56.3,45.8 -76.8,75.3 -2.4,5.1 -4.6,10.2 -6.6,15.4 v 0 c 22.1,-34.4 50.6,-65.4 83.4,-90.7",
    style: {
      fill: "#feefd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13363.2,4152.4 c -36,25 -70.5,51.9 -103.4,80.1 -37.9,92.4 -54.1,193.8 -69.6,291.5 -22.4,140.7 -46.1,281.2 -70.1,421.6 -5.5,32.5 -6.7,70.8 -17.9,101.7 -18,49.6 -31.7,55.5 -56.8,68.9 -0.2,1.4 -0.5,2.8 -0.7,4.2 -8.6,12.1 -17.9,23.4 -27.3,34.4 -29.1,34.3 -59.5,66.4 -76.4,114.3 v 0 c -0.6,1.6 -1.2,3.3 -1.7,4.9 -0.2,0.4 -0.3,0.7 -0.4,1.1 v 0 c -1.2,3.6 -2.3,7.3 -3.4,11 -7.9,26.6 -12.3,53.9 -13.1,82 v 0 0 c -0.1,1.3 -0.1,2.7 -0.1,4.1 0,8 0.5,16.4 1.3,25 0.6,7.8 1.4,15.8 2.1,23.8 0.9,3.1 1.8,6.3 2.6,9.6 11.6,50 -5.3,45.8 -48,62.6 -17.2,6.7 -33.2,15.1 -48.1,24.8 -32.8,25.3 -61.3,56.3 -83.4,90.7 -18.8,29.1 -32.9,60.8 -41.2,93.5 v 0 c -6.3,25.2 -10.5,52.8 -12.1,81.1 v 0 c 0,0.2 -0.1,0.5 -0.1,0.7 0,0 0,0.1 0,0.2 0,0.1 0,0.3 0,0.4 0,0.2 0,0.3 0,0.4 0,0.1 0,0.2 0,0.3 -0.1,0.2 -0.1,0.3 -0.1,0.5 0,0 0,0.1 0,0.2 0,0.2 0,0.3 0,0.5 v 0.1 c 0,0.2 0,0.4 0,0.7 -0.7,55.2 11.2,110.4 36.4,158.6 9.6,18.3 25.6,25.9 41.6,25.9 32,0 64.2,-30.7 45.5,-67.9 -44.1,-88.1 -29,-190.3 32.2,-266.8 15.1,-19 36.7,-34.1 59.3,-48.5 15.7,-22.1 33.9,-42.5 52.7,-60.5 17.9,-17.3 37.1,-33.2 57.2,-47.9 9.8,-43.5 -12.9,-84.4 -12.9,-127.9 -0.1,-56.3 24.2,-106.6 64.2,-145.1 30.3,-29.1 63.9,-50.7 83.6,-89.4 23.8,-46.9 27.4,-105.7 38.7,-156.2 52.5,-236.5 111.9,-471.1 147,-710.9 5.3,-36.7 12.5,-69 22.4,-98.3",
    style: {
      fill: "#fdddb8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13606.8,3767.2 c -0.8,0 -1.7,0.1 -2.6,0.3 -26.6,6.8 -34.3,20.8 -41.7,47.2 -10.1,35.4 -0.6,58.5 -34.5,91.2 -18.1,17.5 -45.9,24.9 -66.7,38.2 -79.5,50.8 -126.7,146.2 -171.4,225.9 -11.4,20.3 -21.3,41.2 -30.1,62.5 32.9,-28.2 67.4,-55.1 103.4,-80.1 24.6,-72.7 65.7,-127.3 136.8,-185.5 25.5,-20.9 56.6,-42.5 72.5,-72.3 14.1,-26.5 7.8,-94.7 38.9,-105.3 11.6,-4 6.2,-22.1 -4.6,-22.1",
    style: {
      fill: "#fcd0aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15406,5591.2 c 3,36.7 0,73.9 -9.3,109.9 -8.6,33.2 19.8,57.1 45.5,57.1 15.2,0 29.4,-8.3 34.5,-28 8.6,-33.2 12.7,-66.1 12.6,-98.3 -25.2,-17.6 -53.2,-31.2 -83.3,-40.7",
    style: {
      fill: "#feefd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15382.9,5490.7 c -0.4,0 -0.9,0 -1.4,0 13.4,31.8 21.7,65.9 24.5,100.5 30.1,9.5 58.1,23.1 83.3,40.7 0,-43 -7.5,-84.6 -21.7,-123.9 -20.1,-9.1 -41.1,-15.5 -63.1,-16.7 -7.2,-0.4 -14.4,-0.6 -21.6,-0.6",
    style: {
      fill: "#fdddb8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14334.2,3750.5 c -51.6,0 -102.7,4.4 -152.4,14.5 -8.7,1.8 -8.2,15.2 0.9,15.7 194.2,11.1 376.5,7.9 564.4,71.7 174.1,59.2 393,138 445.5,332 48,177.2 66,367.1 82.6,549.4 9.1,100.3 18.5,200.5 26.8,300.9 4.1,50.4 54.9,254.3 -10.7,281.5 -22,9.1 -21.6,39.5 -4.2,52.4 42.6,31.9 74.3,74.4 94.4,122.1 0.5,0 1,0 1.4,0 7.2,0 14.4,0.2 21.6,0.6 22,1.2 43,7.6 63.1,16.7 -22,-60.8 -60.1,-116 -111.6,-161.7 35.9,-33.4 47.1,-83.8 46.7,-136.2 -1.1,-114.5 -13.3,-229.1 -25.5,-342.7 -14,-130 -34.6,-259.1 -52.7,-388.5 -14.2,-100.8 -20.9,-210.3 -59.5,-305.4 -35,-86 -96.9,-153 -176.7,-198.8 -92.3,-52.8 -174.2,-104.6 -277.7,-136.2 -148.1,-45.2 -315.1,-88 -476.4,-88",
    style: {
      fill: "#fcd0aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15055,5235.6 c -14.6,0 -19.9,22.2 -4.6,29.6 38.9,18.7 79.5,44.1 121.9,53.5 1.4,0.4 2.8,0.5 4.1,0.5 15.9,0 28.1,-20.2 11.7,-30.9 -37.7,-24.6 -85.3,-36.4 -127.3,-51.6 -2.1,-0.8 -4,-1.1 -5.8,-1.1",
    style: {
      fill: "#fdddb8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14600.9,5649.3 c -3.2,0 -6.4,0.1 -9.6,0.1 -32.1,0.3 -36.9,47.2 -4.1,50.3 159.1,15.2 319.1,59.1 463.6,127.3 146.1,68.9 268,172.1 396.7,267.7 1.8,1.3 3.8,1.9 5.7,1.9 7.4,0 14.5,-8 10.2,-15.5 -164.8,-288.2 -544,-431.8 -862.5,-431.8",
    style: {
      fill: "#feefd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15480.4,6157.9 c -27.7,0 -30.4,43.8 -1.5,46.1 0.7,0 1.4,0.1 2.1,0.1 27.7,0 30.4,-43.8 1.5,-46.1 -0.7,-0.1 -1.4,-0.1 -2.1,-0.1",
    style: {
      fill: "#fffaf8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14114.6,5578.8 c -14.7,0 -16.1,23.3 -0.8,24.5 l 39,3.1 c 0.4,0 0.8,0.1 1.2,0.1 14.7,0 16.1,-23.3 0.8,-24.5 l -39,-3.2 c -0.4,0 -0.8,0 -1.2,0",
    style: {
      fill: "#feefd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13594.4,4395.1 c -9.8,-0.8 -7.4,-15.9 2.3,-15.1 9.8,0.8 7.5,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13560.4,4827.3 c -1.3,-0.1 -1,-2.1 0.3,-2 1.3,0.1 1,2.1 -0.3,2",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14158.2,4984.7 c -9.8,-0.7 -7.5,-15.8 2.3,-15.1 9.8,0.8 7.4,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14111.3,4649.8 c -9.7,-0.8 -7.4,-15.9 2.3,-15.1 9.8,0.8 7.5,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14146.1,4494.9 c 0.9,4.6 -2.3,10.3 -8.4,9.8 -4.7,-0.3 -6.5,-3.9 -6.2,-7.5 -27.1,-4.3 -27.3,-47.8 1.4,-45.5 24.2,1.9 28.9,33.6 13.2,43.2",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13953.7,4872.7 c -9.8,-0.7 -7.5,-15.8 2.3,-15.1 9.8,0.8 7.5,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14523.5,4925.6 c -9.8,-0.8 -7.4,-15.9 2.3,-15.1 9.8,0.8 7.5,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14050.8,4210.8 c -9.8,-0.8 -7.5,-15.9 2.2,-15.1 9.8,0.8 7.5,15.8 -2.2,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14700.8,4549.7 c -9.8,-0.8 -7.5,-15.9 2.2,-15.1 9.8,0.8 7.5,15.9 -2.2,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14895.3,4970 c -9.8,-0.8 -7.4,-15.8 2.3,-15.1 9.8,0.8 7.5,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14360.9,4934.7 c -9.8,-0.8 -7.5,-15.9 2.3,-15.1 9.8,0.8 7.5,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14533.7,4705.6 c -9.8,-0.7 -7.4,-15.8 2.3,-15.1 9.8,0.8 7.5,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14800.6,5050.8 c -9.8,-0.8 -7.5,-15.9 2.2,-15.1 9.8,0.8 7.5,15.8 -2.2,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13935.9,5003.8 c -9.8,-0.8 -7.5,-15.9 2.3,-15.1 9.8,0.8 7.4,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13550.3,4855.2 c -9.8,-0.7 -7.4,-15.8 2.3,-15.1 9.8,0.8 7.5,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13546.2,4722.4 c -9.8,-0.7 -7.5,-15.8 2.3,-15.1 9.8,0.8 7.5,15.9 -2.3,15.1",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13589.4,4557.5 c -39.2,-3.1 -34.4,-64 4.8,-60.8 39.2,3.1 34.4,64 -4.8,60.8",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13523.3,4831.9 c -39.2,-3.1 -34.4,-64 4.9,-60.9 39.1,3.2 34.3,64 -4.9,60.9",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13887.8,4875.7 c -39.2,-3.1 -34.4,-64 4.8,-60.8 39.2,3.1 34.4,64 -4.8,60.8",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13941.1,4945.2 v -0.3 0.3",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14232.2,4863.8 c 0.5,3.1 -1.3,6.7 -5.4,6.4 l -1.2,-0.4 c -3.1,1.7 -6.9,2.6 -11.5,2.2 -29.3,-2.3 -30.2,-48.3 -0.7,-45.9 20.6,1.7 27.1,24.9 18.8,37.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14007.4,4300.7 c -6.9,-0.6 -6.2,-11.2 0.7,-10.7 6.8,0.6 6.2,11.2 -0.7,10.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13846.7,4204 c -12.6,-1 -12.9,-20.7 -0.3,-19.7 12.5,1 12.9,20.7 0.3,19.7",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14614.2,4653.8 c -29.2,-2.4 -30.1,-48.3 -0.7,-46 29.3,2.4 30.1,48.3 0.7,46",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14283.2,4821.9 c -14.5,-1.2 -15,-24 -0.3,-22.9 14.5,1.2 15,24 0.3,22.9",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14785.6,4719 c -29.2,-2.4 -30.1,-48.3 -0.7,-46 29.3,2.4 30.2,48.3 0.7,46",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13877.6,4661.2 c -29.2,-2.4 -30.1,-48.3 -0.6,-46 29.2,2.4 30.1,48.3 0.6,46",
    style: {
      fill: "#f6842c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13906.3,4670.8 c -29.2,-2.3 -30.1,-48.3 -0.7,-45.9 29.3,2.3 30.2,48.3 0.7,45.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13693.8,4922 c -14.6,-1.1 -15,-24.1 -0.3,-22.9 14.6,1.1 15,24.1 0.3,22.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14230,4751.4 c -14.7,-1.1 -15.1,-24.1 -0.4,-22.9 14.6,1.1 15.1,24.1 0.4,22.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14233.8,5163.9 c -14.6,-1.2 -15,-24.2 -0.3,-23 14.6,1.2 15,24.2 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14752.4,4844.7 c -14.6,-1.2 -15.1,-24.2 -0.3,-23 14.6,1.2 15,24.2 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14173.2,4540.8 c -14.6,-1.1 -15.1,-24.1 -0.3,-22.9 14.6,1.1 15,24.1 0.3,22.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13725.3,4343.2 c -14.6,-1.2 -15,-24.2 -0.3,-23 14.6,1.2 15.1,24.1 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14094.8,4232.8 c -14.7,-1.1 -15.1,-24.1 -0.4,-22.9 14.6,1.1 15.1,24.1 0.4,22.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14630.9,4607 c -5.5,-0.4 -5.7,-9.1 -0.1,-8.6 5.5,0.4 5.6,9.1 0.1,8.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14875.8,4773.6 c -14.6,-1.2 -15,-24.2 -0.3,-23 14.6,1.2 15.1,24.2 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14801.8,4318.7 c -14.7,-1.1 -15.1,-24.1 -0.4,-22.9 14.7,1.1 15.1,24.1 0.4,22.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14034.5,4250.1 c -14.6,-1.2 -15.1,-24.1 -0.3,-23 14.6,1.2 15,24.2 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13632,4497.6 c -14.6,-1.2 -15,-24.1 -0.3,-23 14.6,1.2 15.1,24.2 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13791.8,4893.1 c -14.6,-1.2 -15.1,-24.2 -0.3,-23 14.6,1.2 15,24.1 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14434.8,4951.8 c -14.7,-1.2 -15.1,-24.2 -0.4,-23 14.6,1.2 15.1,24.2 0.4,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14216.5,4551.7 c -14.6,-1.2 -15.1,-24.2 -0.3,-23 14.6,1.2 15,24.1 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13750.5,4396.7 c -14.6,-1.2 -15.1,-24.2 -0.3,-23 14.6,1.2 15,24.2 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13844.9,4589 c -6.2,-0.5 -6.4,-10.3 -0.1,-9.8 6.2,0.5 6.4,10.3 0.1,9.8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13583.2,4648.3 c -14.6,-1.2 -15.1,-24.2 -0.3,-23 14.6,1.2 15,24.1 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path410"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14456.9,4305.9 c -14.6,-1.2 -15.1,-24.1 -0.3,-23 14.6,1.2 15,24.2 0.3,23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14609.7,4973.1 c -14.7,-1.2 -15.1,-24.1 -0.4,-22.9 14.7,1.1 15.1,24.1 0.4,22.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14365.7,7213.2 c 527.7,-97 949.5,-540.4 1020.9,-1073.2 6.7,-50.4 87,-51.1 80.2,0 -76,566.7 -513.8,1046.5 -1079.8,1150.5 -50.4,9.3 -72.1,-67.9 -21.3,-77.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12881.2,5869.7 c -44.4,603 347.7,1163.2 931.8,1320.7 49.8,13.4 28.7,90.8 -21.3,77.3 -616.3,-166.1 -1037.6,-760.2 -990.7,-1398 3.7,-51.2 83.9,-51.6 80.2,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12774.6,5837.7 c 300.2,-214.2 693,-220.5 1047.4,-223.1 224.6,-1.6 449.3,11 671.9,41.4 188.7,25.8 377.5,59.5 552.8,136.6 179.5,79 339.3,198.5 448.7,362.6 28.7,43.1 -40.7,83.2 -69.2,40.5 -270.8,-406.1 -825.3,-466.1 -1270.2,-492.5 -235.7,-14 -475.8,-14.5 -711.3,5.3 -222,18.7 -445.4,67 -629.6,198.4 -42.1,30.1 -82.2,-39.5 -40.5,-69.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12797,6070.5 c -215.1,-109.5 -179.1,-416.6 -23.6,-560.2 100.2,-92.6 233,-139.5 363.8,-169.3 168,-38.3 341.6,-58.2 513.6,-67 359.9,-18.4 721.3,20.7 1073.3,95.3 252.7,53.6 527.4,127.9 718.6,312.2 95.8,92.3 176.6,221.7 173.3,358.7 -3.3,138.8 -78.6,267.2 -195.6,340.5 -43.8,27.4 -84.1,-41.9 -40.5,-69.3 100.5,-63 162.9,-179.2 155.4,-298.5 -7,-111.2 -82.6,-214 -162.3,-286.9 -165.1,-151.1 -395.1,-217.2 -608.4,-265.8 -293.6,-66.9 -594.2,-107 -895.5,-110.3 -276.7,-3 -575.9,13 -839.5,104.6 -123.5,42.9 -250,120.6 -290.2,252.4 -33.1,108.4 -9.7,239.5 98.1,294.4 46,23.4 5.5,92.6 -40.5,69.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12867.6,5457.8 c -4.7,-146.1 24.7,-303.9 160,-384.8 139.8,-83.6 312.5,-72.5 468.8,-87.6 51.3,-5 51,75.2 0,80.1 -136,13.2 -288.3,2 -412.8,68 -121.2,64.2 -139.8,199.3 -135.8,324.3 1.6,51.6 -78.5,51.5 -80.2,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15450.6,5763.3 c 8.5,-122.5 9.4,-270.7 -83.1,-364.7 -45.1,-45.7 -108.5,-70.3 -165.5,-97.8 -72.4,-34.9 -146.9,-62.8 -225.2,-81.2 -50.2,-11.8 -29,-89.1 21.3,-77.3 86.4,20.2 168.4,52.4 248.1,91 64.8,31.4 133,60.4 183.1,113.9 103.6,110.9 111.4,272.8 101.5,416.1 -3.5,51.2 -83.7,51.6 -80.2,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15387.5,5411.1 c -22.1,-230.4 -39.7,-461.2 -63.5,-691.4 -11.1,-107 -26,-213.4 -39.4,-320.1 -17.1,-136.6 -34.3,-290.6 -147.7,-383.9 -102.3,-84.1 -237.7,-124.4 -366.8,-141.4 -159.7,-21 -320.4,-37.1 -481.4,-42.3 -158.8,-5.1 -318.4,0.7 -475.6,24.8 -147.9,22.6 -310.2,48.9 -424.4,153.8 -64.4,59.1 -86.2,140.8 -103.8,223.3 -19.5,91.2 -38.6,182.4 -59.6,273.2 -44.5,192.5 -91.9,384.4 -131.6,578 -10.4,50.5 -87.7,29.1 -77.4,-21.4 38.1,-185.1 83.1,-368.7 125.8,-552.8 21.5,-92.3 41.8,-184.7 61.2,-277.4 15,-72.2 30.7,-146.9 70.6,-210.2 77.6,-123.1 221.2,-181.8 356.9,-213.1 161.9,-37.2 327.8,-55.8 493.7,-59.4 177.2,-3.9 354.4,9.3 530.4,29.2 146.4,16.6 285.7,35.3 419.1,101.7 123,61.3 208,151.7 248.9,284 38.6,124.9 46.8,261.6 63,390.9 35.4,284 54.5,569.7 81.8,854.5 4.9,51.3 -75.3,51 -80.2,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13424.2,3893 c 26,-67.9 41.8,-145.5 94.1,-199.5 48.7,-50.3 123.2,-75.8 188.1,-97.3 176.8,-58.6 362.7,-79.7 548.4,-72.5 179.9,7 377.3,21.3 549.2,78.3 150.2,49.9 275.3,146.7 305.2,308.8 9.3,50.4 -68,72.1 -77.3,21.3 -28.7,-155.5 -156.7,-230.1 -300.3,-267.7 -153.4,-40.1 -318.8,-54.4 -476.8,-60.5 -155.7,-6 -309.3,8.2 -459.7,49.4 -64.9,17.7 -136.1,37.3 -192.7,75 -62.7,41.8 -75.6,120 -100.8,186 -18.3,47.7 -95.9,27 -77.4,-21.3",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15061.1,6385.8 c 43.5,26.1 113.1,24.4 158.7,4.4 26.1,-11.5 52.2,-29.7 70.7,-46.5 23,-20.8 36.5,-41.9 50.4,-71.8 9.1,-19.6 37.4,-24.6 54.8,-14.4 20.2,11.8 23.6,35.2 14.4,54.9 -32.3,69.6 -92.6,123.8 -163.5,152.9 -69.5,28.4 -160.4,29.1 -226,-10.3 -44.1,-26.5 -3.9,-95.9 40.5,-69.2",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13718.8,8284.5 c 26.4,-638.3 52.6,-1276.5 78.9,-1914.8 2.1,-51.4 82.3,-51.7 80.2,0 -26.3,638.3 -52.5,1276.5 -78.9,1914.8 -2.1,51.4 -82.3,51.7 -80.2,0",
    style: {
      fill: "#42332f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13805.7,8291.4 c 3,10.9 -1.3,-2.1 1.3,4.4 0.8,1.8 8.5,12.5 2.6,4.9 5.7,7.3 14.2,14.2 15.5,15.1 17.8,12.8 34.5,20.1 52.8,26.6 51.6,18.1 106.4,26.4 160.9,29 54.7,2.5 110.7,0.2 164,-13.7 23,-6 37.6,-10.8 56.7,-22.3 10.7,-6.4 8.7,-4.7 18.4,-14.4 1.6,-1.7 3.2,-3.4 4.7,-5.2 -2.8,3.7 -2.9,3.6 -0.3,0 1.3,-1.8 6.8,-14.2 3.3,-5.2 18.6,-47.6 96.1,-26.9 77.3,21.3 -35.1,90 -147.4,110.9 -232.8,118.1 -102.3,8.6 -214.8,-1.9 -309.2,-44.7 -40.4,-18.3 -80.2,-47.9 -92.5,-92.6 -13.7,-49.8 63.6,-71.1 77.3,-21.3",
    style: {
      fill: "#42332f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14445.4,6580.7 c -25.2,571.1 -49.1,1142.3 -73.6,1713.4 -2.2,51.4 -82.4,51.7 -80.2,0 24.6,-571.1 48.4,-1142.3 73.6,-1713.4 2.2,-51.4 82.4,-51.7 80.2,0",
    style: {
      fill: "#42332f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13820.3,8296.5 c -31.7,-57.8 26.3,-104.7 77.7,-118 55.8,-14.5 115.8,-9.6 172.3,-2.2 40,5.2 81.4,9.5 120.8,18.4 32.1,7.2 73.1,21.2 82.3,57.1 13.1,51 -45.7,104.6 -93.3,105.5 -25.8,0.5 -25.8,-39.6 0,-40.1 26.7,-0.5 76.6,-45.5 43.3,-68.3 -26.3,-18.1 -64.9,-20 -95.6,-24.1 -49,-6.6 -97.5,-15 -147,-15.2 -26.1,-0.1 -52.4,1.7 -77.5,9 -23,6.7 -64.7,28 -48.4,57.7 12.4,22.6 -22.2,42.9 -34.6,20.2",
    style: {
      fill: "#42332f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13656.8,7220.6 c -155.6,-137.6 106.6,-281.8 225.1,-299.8 118.4,-17.9 239,-17 357.5,-0.3 96.5,13.6 193.3,35 270.4,97.6 80.1,65 120,166.9 20.5,235 -42.6,29.2 -82.8,-40.2 -40.4,-69.3 67.5,-46.2 -49.1,-124.1 -91,-142.5 -99.5,-44 -221.8,-52.5 -329,-53.5 -88.1,-0.7 -188.1,-0.5 -268.4,40.3 -45.3,23.1 -150.3,80.7 -88,135.8 38.7,34.2 -18.2,90.8 -56.7,56.7",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12991.6,6046.4 c 65.4,173.4 234.3,346.5 433.2,334.5 156,-9.5 338.7,-178 468.4,-10 50.5,65.5 58.5,152.9 106.3,219.5 45.9,64 128.9,89.8 205.1,81.5 86,-9.3 139.6,-59 177.3,-133.5 31.5,-62.2 58.1,-134.9 122.1,-171.3 75,-42.8 151.4,-7.5 213.8,39.7 36.5,27.7 73.7,64.5 119.4,76 63.9,16.1 122.7,-23.1 148.2,-80.2 21,-47 90.2,-6.3 69.3,40.5 -34.8,78 -116.5,128.4 -202.4,123.1 -94.2,-5.7 -147.7,-84.5 -225.7,-124.6 -108.8,-55.9 -147.6,88.4 -187.1,159.8 -38.1,69.2 -97.4,118.7 -173.9,140.2 -154.5,43.5 -307.4,-29.9 -369.2,-176 -18.2,-42.9 -30.7,-89.5 -55.4,-129.2 -40.6,-65 -103.1,-69.3 -171.7,-47.9 -98.2,30.7 -184.4,80.3 -290.8,71.7 -218.6,-17.6 -390.2,-196.1 -464.3,-392.4 -18.2,-48.4 59.3,-69.3 77.4,-21.4",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(31, 30, 30)"
    },
    id: "path444"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabbitWorking);
export default __webpack_public_path__ + "static/media/rabbit-working.ed72c65e.svg";
export { ForwardRef as ReactComponent };